<template>

  <div class="container-fluid">
    <div id="builder" class="row justify-content-center">
      <div class="col">
        <div class="card tab-content">

                    <div :class="['card-header', isTemplate ? 'bg-white' : '']">
    
                        <div class="row d-flex">

                            <div class="col-2 col-sm-3 order-1 order-sm-0">
                              <ul class="nav nav-pills card-header-pills justify-content-start">
                                
                                  
                                  <li class="nav-item">
                                      
                                      <b-form-radio-group
                                        v-model="viewport"
                                        :options="[{ html: '<i class=\'fa fa-desktop\'></i>', text: 'Desktop', value: 'desktop' },
                                                     { html: '<i class=\'fa fa-mobile\'></i>', text: 'Mobile', value: 'mobile' }]"
                                        button-variant="outline-primary"
                                        name="radio-btn-outline"
                                        buttons
                                        class="viewport-switcher"
                                      ></b-form-radio-group>
                      
                                </li>
                              </ul>
                            </div>

                            <div class="col-12 col-sm-6 order-0 order-sm-1">
                              <h4  v-if="!editDeckName" @click="toggleEditDeckName()" class="pt-2 mb-0 pb-1 text-center"><span v-if="isTemplate">Template: </span>{{ deckName }}</h4>
                              <div v-else class="d-flex justify-content-center">

                                  <b-input-group :prepend="isTemplate ? 'Template Name' : 'Deck Name'" class="w-auto">
                                    <b-form-input class="d-inline-block" ref="tempDeckName" id="tempDeckName" v-model="tempDeckName" @keyup.enter="confirmDeckName"></b-form-input>
                                    <b-input-group-append>
                                      <b-button variant="primary" @click="confirmDeckName"><i class="fa fa-check"></i></b-button>
                                      <b-button variant="secondary" @click="discardDeckName"><i class="fa fa-close"></i></b-button>
                                    </b-input-group-append>
                                  </b-input-group>

                              </div>
                              
                            </div>

                            <div class="col-10 col-sm-3 order-2 order-sm-2 pr-0">
                              <ul class="nav nav-pills card-header-pills justify-content-end w-100">

                                <li class="nav-item">
                                      <b-button variant="primary" class="mr-1" @click="saveDeck('preview')" title="Preview"><i class="fa fa-eye"></i></b-button>
                                  </li>
                                <li class="nav-item">
                                    <b-button variant="primary" class="mr-1" @click="openDeckSettings()" title="Open Deck Settings"><i class="fa fa-cogs"></i></b-button>
                                </li>
                                <!--<li class="nav-item">
                                    <b-button variant="primary" class="mr-1" @click="openDeckTemplateDialog()" title="Save a copy of this Deck as Template"><i class="fa fa-heart"></i></b-button>
                                </li>-->
                                <li class="nav-item">
                                    <b-button variant="primary" class="mr-1" @click="saveDeck()" title="Save"><i class="fa fa-save"></i></b-button>
                                </li>
                                <li class="nav-item" v-if="!isTemplate">
                                    <b-button variant="primary" @click="launchDonePop()" title="Done">Done</b-button>
                                </li>
                                <li class="nav-item" v-if="isTemplate">
                                    <b-button variant="primary" @click="saveDeck('close-template')" title="Save & Close">Save & Close</b-button>
                                </li>
                                
                              </ul> 
                            </div>

                          </div>
                          
                    </div>

                    <div :class="['card-body container-fluid h-100','p-0','deck-builder-container',cardsNavActive?'shift':'']" id="deckBuilderContainer" ref="deckBuilderContainer" role="tabpanel" aria-labelledby="builder-tab">


<b-button :class="['minimiseNav tab position-absolute',cardelementsNavActive?'shift':'']" size="sm" variant="primary" @click="toggleCardelementsNav">
                                <span style="position: relative;right: 8px;top: -3px;" v-if="cardelementsNavActive" class="material-symbols-outlined">chevron_left</span>
                                <span style="position: relative;right: 7px;top: -3px;"  v-else class="material-symbols-outlined">chevron_right</span>
</b-button>

                      <div class="row">

                        <div class="builder-cardelements-nav"  id="cardelementsNav">
                              <!--<b-button :class="['minimiseNav position-absolute',cardelementsNavActive?'shift':'']" size="sm" variant="primary" @click="toggleCardelementsNav">
                                <span style="position: relative;right: 8px;top: -3px;" v-if="cardelementsNavActive" class="material-symbols-outlined">chevron_left</span>
                                <span style="position: relative;right: 7px;top: -3px;"  v-else class="material-symbols-outlined">chevron_right</span>
                               </b-button> -->





                              <b-nav vertical >

                                  <draggable v-show="cardelementsNavActive" :group="{ name: 'cardelements', pull: 'clone', put: false }" :sort="false" :clone="cloneCardElement" :list="cardelementtemplatesnav">
                                  <b-nav-item v-for="cardelementtemplate in cardelementtemplatesnav" :key="cardelementtemplate.id"  class="ml-3 mr-1 cardelement-template-nav" @click="addCardElement(cardelementtemplate)">

                                        <img v-if="cardelementtemplate.thumbnail == '{company-logo}'" class="cardelement-preview logo-preview" :src="deckDefaults.logo.includes('/default/placeholder-logo.png') ? '/images/thumbnails/Placeholder-Logo-Panel.png' : deckDefaults.logo" :alt="cardelementtemplate.name " :title="cardelementtemplate.name " />
                                        <img v-else-if="cardelementtemplate.thumbnail == '{avatar}'" class="cardelement-preview w-50 rounded-circle mx-auto d-block" :src="deckDefaults.profile_pic" :alt="cardelementtemplate.name " :title="cardelementtemplate.name " />
                                        <img v-else class="cardelement-preview w-100" :src="cardelementtemplate.thumbnail" :alt="cardelementtemplate.name " :title="cardelementtemplate.name " />

                                  </b-nav-item>
                                  </draggable>

                              </b-nav>

                        </div>


                        <div :class="'col p-0 deckbuilder-build-area deck-style-'+deckStyle" id="buildArea" ref="buildArea">

                        <div :class="'sizzledeck body-size-'+deckBodySize+' heading-size-'+deckHeadingSize+' animation-style-flicking'">



    <div ref="blockContainer" id="blockContainer" :class="['block-container',viewport]" :style="{ backgroundImage: 'url('+deckBackground+')' }">
  
        <div v-if="activeCardIndex>0" :class="['block-nav block-nav-prev background-accent ground',cardelementsNavActive?'shift':'']" @click="flickingPrev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>



        <flicking
          :options="{ 
            circular: false,
            align: 'center',
            moveType: 'strict',

            interruptable: false,

            horizontal: true,
            renderOnlyVisible: false,

            duration: 500,

            // https://easings.net
            easing: x => 1 - Math.pow(1 - x, 3),

            inputType: [] // Disable Dragging

          }"

          @move-start="e =>{
            flickingMoveStart(e);
          }" 
          @move="e =>{
            flickingMove(e);
          }" 
          @move-end="e =>{
            flickingMoveEnd(e);
          }" 

          @will-change="e => {
            flickingWillChange(e);
          }"

          @will-restore="e => {
            flickingWillRestore(e);
          }"
          
          @changed="e => {
            flickingChanged(e);
          }"

          ref="flickingDeck"

        >


          <div :class="[
            'sd-block-wrapper',
            'block['+index+']',
            ]"  v-for="(card, index) in cards" :ref="'card['+index+']'" :data-card-index="index" :style="'z-index:'+(100-index)" >
              

              <div v-if="index==activeCardIndex">

                <!-- Version 1 Card -->
                <div v-if="card.blockTemplateId">
                  <div class="alert alert-danger">Version 1 Card</div>
                  <div v-html="card.html"></div>
                </div>
                
                <!-- Version 2 Card -->
                <div class="card-wrapper" v-else>

                  <div class="card-controls">
                    <b-button variant="outline-primary" size="sm" class="mb-1" @click="copyCard(index)" title="Copy Card"><i class="fa fa-copy"></i></b-button>
                    <b-button variant="outline-primary" size="sm" class="mb-1" @click="openCardSettings(index)" title="Open Card Settings"><i class="fa fa-cogs"></i></b-button>
                  </div>

                  <div :class="['sd-block', 'askin-light', 'p-'+card.content.padding]" data-reference="background" :style="'background-color: '+card.content.backgroundColor+';'">                    

                    <div v-if="cards[index].elements.length==0" class="rounded border border-light text-center text-muted instructions"><p>Card elements go here.</p><p>Click or drag one across to get started!</p></div>

                    <draggable :class="['active-card-draggable',cards[index].elements.length?'':'empty']" :group="{ name: 'cardelements' }" v-model="cards[index].elements" handle=".handle" @update="updateThumbnail=true" @add="updateThumbnail=true" @remove="updateThumbnail=true">

                      <div v-for="(cardElement,elementIndex) in cards[index].elements" class="cardelement" :ref="'cardElement_'+elementIndex" @click="toggleCardElementActive(elementIndex)" :tabindex="elementIndex" >
                          
                          <div class="element-controls left d-flex flex-row"> 
                            
                            <i class="element-control delete-element fa fa-trash" @click="removeElement(elementIndex)"></i>
                            <div class="d-flex flex-column">
                              <i v-show="elementIndex !== 0" class="element-control fa fa-arrow-up" @click="moveElementUp(elementIndex)"></i>
                              <i v-show="elementIndex !== cards[index].elements.length - 1" class="element-control fa fa-arrow-down" @click="moveElementDown(elementIndex)"></i>
                            </div>
                            <i v-if="cards[index].elements.length !== 1" class="element-control move-element fa fa-arrows handle"></i>

                          </div>
                          <div class="element-controls right d-flex flex-row">
                            <i class="element-control fa fa-copy" @click="duplicateElement(elementIndex)"></i>
                            <i class="element-control fa fa-cog" @click="openElementSettings(elementIndex)"></i>
                          </div>


                            <div v-if="cardElement.type=='heading'"
            
                            >
                            <div class="element-controls toolbar">
                              <i :class="['element-control fa fa-header has-sub',cardElement.content.wrapper=='h1'?'selected':'']" @click="setElementSetting(elementIndex,'wrapper','h1')"><sub>1</sub></i>
                              <i :class="['element-control fa fa-header has-sub',cardElement.content.wrapper=='h2'?'selected':'']" @click="setElementSetting(elementIndex,'wrapper','h2')"><sub>2</sub></i>
                              <i :class="['element-control fa fa-header has-sub',cardElement.content.wrapper=='h3'?'selected':'']" @click="setElementSetting(elementIndex,'wrapper','h3')"><sub>3</sub></i>
                              <i :class="['element-control fa fa-align-left',cardElement.content.textAlign=='left'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','left')"></i>
                              <i :class="['element-control fa fa-align-center',cardElement.content.textAlign=='center'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','center')"></i>
                              <i :class="['element-control fa fa-align-right',cardElement.content.textAlign=='right'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','right')"></i>
                              <i :class="['element-control fa fa-align-justify',cardElement.content.textAlign=='justify'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','justify')"></i>
                              <i class="element-control fa fa-user" @click="launchShortcodeModal(elementIndex)"></i>
                            </div>
                            <div :class="[
                                  'pt-'+cardElement.content.paddingTop,
                                  'pb-'+cardElement.content.paddingBottom,
                                  'px-'+cardElement.content.paddingSides,
                                  'text-'+cardElement.content.textAlign,
                                  'font-family-'+cardElement.content.font,
                                  'force-heading-size-'+cardElement.content.fontSize,
                                  ]">
                                <component :is="cardElement.content.wrapper">
                                  <deck-tiptap-heading v-model="cardElement.content.html" :swatches="swatches" :insert="insert" :elementIndex="elementIndex"></deck-tiptap-heading>
                                </component> 
                            </div>
                            </div>

                            <div v-else-if="cardElement.type=='text'">
                            <div class="element-controls toolbar">
                              <i :class="['element-control fa fa-align-left',cardElement.content.textAlign=='left'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','left')"></i>
                              <i :class="['element-control fa fa-align-center',cardElement.content.textAlign=='center'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','center')"></i>
                              <i :class="['element-control fa fa-align-right',cardElement.content.textAlign=='right'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','right')"></i>
                              <i :class="['element-control fa fa-align-justify',cardElement.content.textAlign=='justify'?'selected':'']" @click="setElementSetting(elementIndex,'textAlign','justify')"></i>
                              <i class="element-control fa fa-user" @click="launchShortcodeModal(elementIndex)"></i>
                            </div>
                            <div
                                 :class="[
                                  'pt-'+cardElement.content.paddingTop,
                                  'pb-'+cardElement.content.paddingBottom,
                                  'px-'+cardElement.content.paddingSides,
                                  'text-'+cardElement.content.textAlign,
                                  'font-family-'+cardElement.content.font,
                                  'force-body-size-'+cardElement.content.fontSize,
                                  ]"
                            >
                              <deck-tiptap-text v-model="cardElement.content.html" :swatches="swatches" :insert="insert" :elementIndex="elementIndex"></deck-tiptap-text>
                             
                            </div>
                            </div>



                            <div v-else-if="cardElement.type=='image'" 
                                
                            >
                            <div class="element-controls image-toolbar">
                       
                              <div class="d-flex justify-content-center">

                                <i class="element-control fa fa-upload lg mr-2" @click="launchSelectImage(elementIndex)" title="Replace Image"></i>

                                <i :class="['element-control fa fa-plus lg',cardElement.content.width=='w-100'?'selected':'']" @click="setImageSize(elementIndex,cardElement.content.width,'increase')"></i>
                                <i :class="['element-control fa fa-minus lg',cardElement.content.width=='w-5'?'selected':'']" @click="setImageSize(elementIndex,cardElement.content.width,'decrease')"></i>


                                <!-- <i :class="['element-control fa fa-picture-o lg icon100',cardElement.content.width=='w-100'?'selected':'']" @click="setElementSetting(elementIndex,'width','w-100')"></i>
                                <i :class="['element-control fa fa-picture-o lg icon75',cardElement.content.width=='w-75'?'selected':'']" @click="setElementSetting(elementIndex,'width','w-75')"></i>
                                <i :class="['element-control fa fa-picture-o lg icon50',cardElement.content.width=='w-50'?'selected':'']" @click="setElementSetting(elementIndex,'width','w-50')"></i>
                                <i :class="['element-control fa fa-picture-o lg icon25',cardElement.content.width=='w-25'?'selected':'']" @click="setElementSetting(elementIndex,'width','w-25')"></i>
                                <i :class="['element-control fa fa-picture-o lg icon12_5',cardElement.content.width=='w-12_5'?'selected':'']" @click="setElementSetting(elementIndex,'width','w-12_5')"></i> -->

                                <i v-if="cardElement.content.width != 'w-100'" :class="['element-control fa fa-align-left lg ml-2',cardElement.content.align=='text-left'?'selected':'']" @click="setElementSetting(elementIndex,'align','text-left')"></i>
                                <i v-if="cardElement.content.width != 'w-100'" :class="['element-control fa fa-align-center lg',cardElement.content.align=='text-center'?'selected':'']" @click="setElementSetting(elementIndex,'align','text-center')"></i>
                                <i v-if="cardElement.content.width != 'w-100'" :class="['element-control fa fa-align-right lg',cardElement.content.align=='text-right'?'selected':'']" @click="setElementSetting(elementIndex,'align','text-right')"></i>

                              </div> 
                                                       
                            </div>
                              <div v-html="parseHTML(cardElement)"></div>
                            </div>

                            <div v-else-if="cardElement.type=='button'"
            
                            >
                            
                            <a :class="[
                                  'btn btn-sizzle d-block',
                                  'btn-'+cardElement.content.size,
                                  'mt-'+cardElement.content.marginTop,
                                  'mb-'+cardElement.content.marginBottom,
                                  'mx-'+cardElement.content.marginSides,
                                  (cardElement.content.buttonColor !== null && cardElement.content.buttonColor !== '') ? '' : 'background-accent',
                                  (cardElement.content.textColor !== null && cardElement.content.textColor !== '') ? '' : 'ground',
                                  'font-family-'+cardElement.content.font,
                                  ]"
                                
                                :style="{
                                  backgroundColor: (cardElement.content.buttonColor !== null || cardElement.content.buttonColor !== '') ? cardElement.content.buttonColor : '',
                                  color: (cardElement.content.textColor !== null || cardElement.content.textColor !== '') ? cardElement.content.textColor : '',
                                }"
                              >
                                  <deck-tiptap-heading v-model="cardElement.content.html" :swatches="swatches" :insert="insert" :elementIndex="elementIndex"></deck-tiptap-heading>
                                  
                            </a>
                            </div>
                          
                            <div v-else v-html="parseHTML(cardElement)"></div>

                      </div>
                    </draggable>
                    <div v-if="!premiumAccount" v-html="advert" class="advert-wrapper" @click="upgradeDialog"></div>
                </div>
                </div>

              </div>
              <div v-else>
                <div v-html="card.html"></div>
              </div>

            


          </div> 




        </flicking>



        <div v-if="activeCardIndex<(cards.length - 1)" :class="['block-nav block-nav-next background-accent ground',cardelementsNavActive?'shift':'']" @click="flickingNext"><i class="fa fa-angle-right" aria-hidden="true"></i></div>  

         

    </div>
    </div>



                        </div>
                        </div>

                    </div>
                    <div :class="['card-footer deck-builder-card-navigation-container position-relative', isTemplate ? 'bg-white' : '', cardsNavActive?'shift':'']">
                    	<div class="minimiseNavContainter">
                      <b-button class="minimiseNav" size="sm" variant="primary" @click="toggleCardsNav">

                        

                                <span style="position: relative;right: 8px;top: -3px;" v-if="cardsNavActive" class="material-symbols-outlined">expand_more</span>
                                <span style="position: relative;right: 8px;top: -3px;"  v-else class="material-symbols-outlined">expand_less</span>

                      </b-button></div>
                      <draggable v-if="cardsNavActive" class="deck-builder-card-navigation" v-model="cards" group="cards" @start="" @end="" @add="" >
                        <div v-for="(card, index) in cards" :class="(activeCardIndex==index?'active-card':'')+' card-preview-container rounded'" @click="flickingMoveTo(index)" :ref="'preview['+index+']'" :style="{'background-image':'url(\''+card.content.thumbnail.url+'\')'}"><a v-if="cards.length !== 1" class="delete-card btn btn-sm btn-primary" href="javascript:" @click="removeCard(index)" ><i class="fa fa-trash"></i></a></div>
                        <div class="addNewCard rounded" @click="chooseNewCard()"><i class="fa fa-plus-circle text-pink" aria-hidden="true"></i></div>
                      </draggable>
                    </div>

        </div>


                     <div class="d-none">DEBUG cards[activeCardIndex]: <pre>{{ cards[activeCardIndex] }}</pre></div> 
                     <div class="d-none">DEBUG cards: <pre>{{ cards }}</pre></div>
                     <div class="d-none" v-if="cards[activeCardIndex] && cards[activeCardIndex].elements[activeElementIndex]">DEBUG cards[activeCardIndex]: <pre>{{ cards[activeCardIndex].elements[activeElementIndex] }}</pre></div> 
                     

      </div>


      <!-- Done Modal -->
      <b-modal id="deck-done-modal" ref="deck-done-modal" size="sm" hide-footer title="All Done - Great Job!" body-class="pb-0 pt-0">

          <b-row>
            <b-col cols="12">
              <b-button @click="saveDeck('send')" variant="primary" block>Share Deck</b-button>
            </b-col>
          </b-row>
          <!--<p class="text-muted pt-2"><small>Ping this deck to an individual or group by SMS, email or by sharing the link.</small></p>-->
          <p></p>
          <b-row>
            <b-col cols="12">
              <b-button @click="saveDeck('close-draft')" variant="outline-primary" block>Save as Draft</b-button>
            </b-col>
          </b-row>
          <!-- <p class="text-muted pt-2"><small>Save this deck so you can work on it later.</small></p> -->

<!--  

        	<hr />

          <b-form-group
      
      description="Decks saved in your library can be used as starting point for new decks and be connected to website forms."
      label="Advanced"
    >
          <b-row>
            <b-col cols="12">
              <b-button @click="saveDeck('make-template')" variant="outline-secondary" block>Save as Library Deck</b-button>
            </b-col>
          </b-row>
        </b-form-group>
-->
      </b-modal>

      <!-- New Card (template selection) Modal -->
      <b-modal ref="old-new-card-modal" id="old-new-card-modal" title="What kind of card would you like to add?" size="lg" :hide-footer="true">
          <b-row>
            <b-col cols="8">
              <img class="w-100 rounded" :src="newCardPreview" ref="newCardPreview">
            </b-col>
            <b-col cols="4">
              <b-button @mouseover="changeNewCardPreview()" @click="addNewCard()" variant="primary" block>Add a Blank Card</b-button>
              <b-button @mouseover="changeNewCardPreview('cta')" @click="addNewCard('cta')" variant="primary" block>Add a Contact Card</b-button>
              <b-button @mouseover="changeNewCardPreview('cover')" @click="addNewCard('cover')" variant="primary" block>Add a Cover Card</b-button>
            </b-col>
          </b-row>
      </b-modal>

      <b-modal ref="new-card-modal" id="new-card-modal" title="What kind of card would you like to add?" size="lg" :hide-footer="true">
        <div class="d-flex">
          <b-card
            img-src="/images/thumbnails/New-Card-Blank.png"
            img-alt="Image"
            img-top
            body-class="pb-0"
            style="min-width: 20rem;cursor:pointer;"
            class="mb-4 px-2"
            @click="addNewCard()"
          >
            <template #footer>
              <b-button   variant="primary" block>Add Blank Card</b-button>
            </template>
          </b-card>
          <b-card
            img-src="/images/thumbnails/New-Card-Intro.png"
            img-alt="Image"
            img-top
            body-class="p-0"
            style="min-width: 20rem;cursor:pointer;"
            class="mb-4 px-2"
            @click="addNewCard('intro')"
          >
            <template #footer>
              <b-button   variant="primary" block>Add Intro Card</b-button>
            </template>
          </b-card>
          <b-card
            img-src="/images/thumbnails/New-Card-Cover.png"
            img-alt="Image"
            img-top
            body-class="p-0"
            style="min-width: 20rem;cursor:pointer;"
            class="mb-4 px-2"
            @click="addNewCard('cover')"
          >
            <template #footer>
              <b-button   variant="primary" block>Add Cover Card</b-button>
            </template>
          </b-card>
          <b-card
            img-src="/images/thumbnails/New-Card-CTA.png"
            img-alt="Image"
            img-top
            body-class="p-0"
            style="min-width: 20rem;cursor:pointer;"
            class="mb-4 px-2"
            @click="addNewCard('cta')"
          >
            <template #footer>
              <b-button  variant="primary" block>Add Contact Card</b-button>
            </template>
          </b-card>


</div>

      </b-modal>

      <!-- Settings Modals -->

      <!-- // Deck Settings -->
      <b-modal  id="deckSettings" ref="deckSettings" title="Deck Settings" size="lg" :hide-footer="false" ok-only ok-title="Close">
        <b-form-group label="Deck Background">
          <div title="Set Deck Background" class="deckBackgroundThumb" @click="launchSelectDeckBackground" :style="{ backgroundImage: 'url('+deckBackground+')' }"></div>
        </b-form-group>       


        <!-- 
        <b-form-group label="Show Avatar & Profile ">
            <b-form-radio-group
              v-model="deckUserProfile"
              :options="[{ text: 'Show', value: true },
                           { text: 'Hide', value: false }]"
              button-variant="outline-primary"
              
              name="radio-btn-outline"
              buttons
            ></b-form-radio-group>
        </b-form-group>
        <b-form-group label="Show Logo & Company Info">
            <b-form-radio-group
              v-model="deckCompanyProfile"
              :options="[{ text: 'Show', value: true },
                           { text: 'Hide', value: false }]"
              button-variant="outline-primary"
              
              name="radio-btn-outline"
              buttons
            ></b-form-radio-group>
        </b-form-group>
        -->


        <b-form-group label="Share Image">

            <b-form-radio-group
              v-model="dynamicOgImage"
              :options="[{ text: 'Automatically Set', value: true },
                           { text: 'Manually Set', value: false }]"
              button-variant="outline-primary"
              
              name="radio-btn-outline"
              buttons
              
              @change="dynamicOgImage ? launchOgImagePop() : null"
              @achange="launchOgImagePop"
            ></b-form-radio-group>

            <div v-if="!dynamicOgImage">
              <img v-if="staticOgImage" class="mt-3 deckBackgroundThumb" v-bind:src="staticOgImage" @click="launchOgImagePop" title="Set Share Image" />
              <b-button v-else class=" mt-3" href="#" @click="launchOgImagePop" title="Set Share Image">Open Media Library</b-button>
            </div>

            <p class="small text-muted">Please note, for best results share images should be 1200 x 630 pixels.</p>

        </b-form-group>

        <hr />

       <b-form-group label="Profile">
            <b-form-radio-group
              v-model="deckProfile"
              :options="[{ text: 'Use Deck Defaults', value: null },
                          { text: 'Show', value: 'show' },
                           { text: 'Hide', value: 'hide' }]"
              button-variant="outline-primary"
              
              name="radio-btn-outline"
              buttons
            ></b-form-radio-group>
        </b-form-group>


<!--
        <b-form-group v-if="deckProfile" label="Which image to use in the profile?">
            <b-form-radio-group
              v-model="deckProfileImage"
              :options="[{ text: 'None', value: 'none' },
                         { text: 'Logo', value: 'logo' },
                         { text: 'Profile Pic', value: 'profile_pic' }]"
              button-variant="outline-primary"
              
              name="radio-btn-outline"
              buttons
            ></b-form-radio-group>
        </b-form-group>

        <b-form-group v-if="deckProfile" label="Profile Bubble Text">
             <b-form-input
              v-model="deckProfileBubbleText"
              rows="3"
            ></b-form-input>
        </b-form-group>
        <b-form-group v-if="deckProfile" label="Profile Bubble Button">
             <b-form-input
              v-model="deckProfileBubbleBtnText"
              rows="3"
            ></b-form-input>
        </b-form-group>
-->

      </b-modal>


      <b-modal  id="saveAsDeckTemplate" ref="saveAsDeckTemplate" title="Save as Deck Template?" size="sm" :hide-footer="false" ok-title="Save as Template" @ok="saveAsDeckTemplate">
        <p>Would you like to save a copy of this deck as a template for future use?</p>
        <b-form-group label="Template Name">
        <b-form-input
              v-model="deckTemplateName"
            ></b-form-input>
          </b-form-group>
      </b-modal>

      <!-- // Element Settings -->
      <b-modal v-if="cards[activeCardIndex] && cards[activeCardIndex].elements[activeElementIndex]" id="activeElementSettings" ref="activeElementSettings" 

      :title="cards[activeCardIndex].elements[activeElementIndex].label ? cards[activeCardIndex].elements[activeElementIndex].label : 'Element' +' Settings'" size="lg" :hide-footer="false" ok-only ok-title="Close">

        <!-- Buttons -->
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('buttonColor')">
          <label class="mr-sm-2" for="card-element-buttonColor">Button Colour</label>
          <card-color-picker :swatches="swatches"  id="card-element-buttonColor"  :value="cards[activeCardIndex].elements[activeElementIndex].content.buttonColor ? cards[activeCardIndex].elements[activeElementIndex].content.buttonColor : deckButtonBackgroundColor " @change="cards[activeCardIndex].elements[activeElementIndex].content.buttonColor = $event"></card-color-picker>
        </b-form-group>
        <!-- // Buttons -->

        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('textColor')">
          <label class="mr-sm-2" for="card-element-textColor">Text Colour</label>
          <card-color-picker :swatches="swatches"  id="card-element-textColor"  :value="cards[activeCardIndex].elements[activeElementIndex].content.textColor ? cards[activeCardIndex].elements[activeElementIndex].content.textColor : deckButtonTextColor" @change="cards[activeCardIndex].elements[activeElementIndex].content.textColor = $event"></card-color-picker>
        </b-form-group>
        

        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].type=='video' && cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('src')">
          <label class="mr-sm-2" for="card-element-select-wrappper">Vimeo/Youtube Video URL</label>
          <b-input-group>
        
          <b-form-input ref="videoUrl" v-model="cards[activeCardIndex].elements[activeElementIndex].content.src"></b-form-input>
          <b-input-group-append>
            <b-button variant="outline-primary" size="sm" @click="replaceVideo">Check URL</b-button>
          </b-input-group-append>
          </b-input-group>
        </b-form-group>  

        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].type=='video' && cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('width') && cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('height')"
          content-cols-lg="4"
        >
        <label>Video Dimensions</label>
        <b-input-group class="pb-2">
          <b-input-group-prepend>
            <b-input-group-text >Width</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input v-model="cards[activeCardIndex].elements[activeElementIndex].content.width"></b-form-input>
        </b-input-group>

        <b-input-group class="pb-2">
          <b-input-group-prepend>
            <b-input-group-text >Height</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input v-model="cards[activeCardIndex].elements[activeElementIndex].content.height"></b-form-input>
        </b-input-group>

        </b-form-group>  


        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('link')">
          <label>Link</label>
          <b-input-group class="pb-2">
            <b-input-group-prepend>
              <b-form-select 
                v-model="cards[activeCardIndex].elements[activeElementIndex].content.link.prefix"
                :options="[
                  {value: 'https://', text: 'https://' },
                  {value: 'http://', text: 'http://' },
                  {value: 'mailto:', text: 'mailto:' },
                  {value: 'tel:', text: 'tel:' },
                ]"
              >
              </b-form-select>
            </b-input-group-prepend>
            <b-form-input v-model="cards[activeCardIndex].elements[activeElementIndex].content.link.url"></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('href')">
          <label>Link</label>
          <b-input-group class="pb-2">
            <b-input-group-prepend>
              <b-input-group-text >URL</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="cards[activeCardIndex].elements[activeElementIndex].content.href"></b-form-input>
          </b-input-group>
        </b-form-group>

        
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('font')">
          <label class="mr-sm-2" for="card-element-select-wrappper">Font</label>
          <b-form-select
            id="card-element-select-wrappper"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[

            { text: 'Deck Default', value: null },
            { text: 'Arial', value: 'arial' }, 
            { text: 'League Spartan', value: 'league-spartan' }, 
            { text: 'Roboto (sans-serif)', value: 'roboto' }, 
            { text: 'Open Sans (sans-serif)', value: 'open-sans' }, 
            { text: 'Lato (sans-serif)', value: 'lato' }, 
            { text: 'Montserrat (sans-serif)', value: 'montserrat' },
            { text: 'Oswald (sans-serif)', value: 'oswald' },
            { text: 'Raleway (sans-serif)', value: 'raleway' },
            { text: 'Merriweather (serif)', value: 'merriweather' },
            { text: 'PT Serif (serif)', value: 'pt-serif' },
            { text: 'Cormorant Garamond (serif)', value: 'cormorant-garamond' },
            { text: 'Playfair Display (serif)', value: 'playfair-display' },

            ]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.font"
          ></b-form-select>
        </b-form-group>          
                
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('fontSize')">
          <label class="mr-sm-2" for="card-element-select-wrappper">Font Size</label>
          <b-form-select
            id="card-element-select-wrappper"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[

            { text: 'Deck Default', value: null },
            { text: 'Small', value: 1 }, 
            { text: 'Medium', value: 2 }, 
            { text: 'Large', value: 3 }, 
            { text: 'Extra Large', value: 4 },

            ]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.fontSize"
          ></b-form-select>
        </b-form-group>          
        
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('size')">
          <label class="mr-sm-2" for="card-element-select-wrappper">Size</label>
          <b-form-select
            id="card-element-select-wrappper"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Large', value: 'lg' }, { text: 'Medium', value: 'md' }, { text: 'Small', value: 'sm' }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.size"
          ></b-form-select>
        </b-form-group>          


        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('wrapper')">
          <label class="mr-sm-2" for="card-element-select-wrappper">Heading Type</label>
          <b-form-select
            id="card-element-select-wrappper"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Title', value: 'h1' }, { text: 'Heading', value: 'h2' }, { text: 'Subheading', value: 'h3' }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.wrapper"
          ></b-form-select>
        </b-form-group>   



        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('textAlign')">
          <label class="mr-sm-2" for="card-element-select-text-align">Alignment</label>
          <b-form-select
            id="card-element-select-text-align"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Left', value: 'left' }, { text: 'Centre', value: 'center' }, { text: 'Right', value: 'right' }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.textAlign"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('marginTop')">
          <label class="mr-sm-2" for="card-element-select-margin-Top">Margin Top</label>
          <b-form-select
            id="card-element-select-margin-Top"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.marginTop"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('marginSides')">
          <label class="mr-sm-2" for="card-element-select-margin-Sides">Margin Sides</label>
          <b-form-select
            id="card-element-select-margin-Sides"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.marginSides"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('marginBottom')">
          <label class="mr-sm-2" for="card-element-select-margin-Bottom">Margin Bottom</label>
          <b-form-select
            id="card-element-select-margin-Bottom"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.marginBottom"
          ></b-form-select>     
          </b-form-group>   
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('paddingTop')">
          <label class="mr-sm-2" for="card-element-select-padding-Top">Padding Top</label>
          <b-form-select
            id="card-element-select-padding-Top"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.paddingTop"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('paddingSides')">
          <label class="mr-sm-2" for="card-element-select-padding-Sides">Padding Sides</label>
          <b-form-select
            id="card-element-select-padding-Sides"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.paddingSides"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('paddingBottom') && cards[activeCardIndex].elements[activeElementIndex].type!='spacer'">
          <label class="mr-sm-2" for="card-element-select-padding-Bottom">Padding Bottom</label>
          <b-form-select
            id="card-element-select-padding-Bottom"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.paddingBottom"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('paddingBottom') && cards[activeCardIndex].elements[activeElementIndex].type=='spacer'">
          <label class="mr-sm-2" for="card-element-select-padding-Bottom">Size</label>
          <b-form-select
            id="card-element-select-padding-Bottom"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Extra Large', value: 5 }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.paddingBottom"
          ></b-form-select>
        </b-form-group>

        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('corners')">
          <label class="mr-sm-2" for="card-element-select-padding-Bottom">Corners</label>
          <b-form-select
            id="card-element-select-padding-Bottom"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Square', value: 'rounded-0' }, { text: 'Rounded', value: 'rounded' }, { text: 'Rounded Top', value: 'rounded-top' }, { text: 'Rounded Bottom', value: 'rounded-bottom' }, { text: 'Circle', value: 'rounded-circle' }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.corners"
          ></b-form-select>
        </b-form-group>

        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('width') && cards[activeCardIndex].elements[activeElementIndex].type!=='video'">
          <label class="mr-sm-2" for="card-element-select-padding-Bottom">Width</label>
          <b-form-select
            id="card-element-select-padding-Bottom"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Full', value: 'w-100' }, { text: '3/4', value: 'w-75' }, { text: '1/2', value: 'w-50' }, { text: '1/4', value: 'w-25' }, { text: '1/8', value: 'w-12_5' }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.width"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].elements[activeElementIndex].content.hasOwnProperty('align')">
          <label class="mr-sm-2" for="card-element-select-padding-Bottom">Alignment</label>
          <b-form-select
            id="card-element-select-padding-Bottom"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'Left', value: 'text-left' }, { text: 'Centre', value: 'text-center' }, { text: 'Right', value: 'text-right' }]"
            v-model="cards[activeCardIndex].elements[activeElementIndex].content.align"
          ></b-form-select>
        </b-form-group>

      </b-modal>

      <!-- Card Settings -->
      <b-modal v-if="cards[activeCardIndex]" id="activeCardSettings" ref="activeCardSettings" title="Card Settings" size="lg" :hide-footer="false" ok-only ok-title="Close">
        <b-form-group v-if="cards[activeCardIndex].content.hasOwnProperty('padding')">
          <label class="mr-sm-2" for="card-element-select-padding">Card Padding</label>
          <b-form-select
            id="card-element-select-padding"
            class="mb-2 mr-sm-2 mb-sm-0"
            :options="[{ text: 'None', value: 0 }, { text: 'Tiny', value: 1 }, { text: 'Small', value: 2 }, { text: 'Medium', value: 3 }, { text: 'Large', value: 4 }, { text: 'Lots', value: 5 }]"
            v-model="cards[activeCardIndex].content.padding"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="cards[activeCardIndex].content.hasOwnProperty('backgroundColor')">
          <label class="mr-sm-2" for="card-element-backgroundColor">Card Background Colour</label>
          <card-color-picker 
            :swatches="swatches"  
            id="card-element-backgroundColor"  
            :value="cards[activeCardIndex].content.backgroundColor ? cards[activeCardIndex].content.backgroundColor : deckGroundColor " @change="cards[activeCardIndex].content.backgroundColor = $event"></card-color-picker>
        </b-form-group>
      </b-modal>
      <!-- // Card Settings -->


      <!-- Media Modals -->

      <!-- // Select Image -->
      <b-modal ref="modal-medialib" id="modal-medialib" title="Media Library" size="xl" :hide-footer="true">
          <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="replaceImage"></sd-media-manager>
      </b-modal>

      <!-- // Select Deck Background -->
      <b-modal ref="choose-background-modal" size="xl" hide-footer title="Choose Deck Background" body-class="pt-0">
        <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="replaceDeckBackground" defaultTab="#solidcolors"></sd-media-manager>
      </b-modal>

      <b-modal id="choose-ogimage-modal" ref="choose-ogimage-modal" size="xl" hide-footer title="Choose Share Image" body-class="pt-0">
        <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="setDeckOgImage"></sd-media-manager>
      </b-modal>


      <!-- Shortcode Modal -->
      <b-modal ref="shortcodeModal" id="shortcode-modal" title="Select a Personalisation Shortcode" :hide-footer="true">
        <div ref="shortcodeCollapseChoose" v-show="!selectedShortcode">
          <b-row>
            <b-col>
              <b-form-group>
                <b-button class="mb-2" variant="primary" @click="selectShortcode('firstname')">First Name</b-button>
                <b-button class="mb-2" variant="primary" @click="selectShortcode('lastname')">Last Name</b-button>
                <b-button class="mb-2" variant="primary" @click="selectShortcode('companyname')">Company</b-button>
                <b-button class="mb-2" variant="primary" @click="selectShortcode('email')">Email</b-button>
                <b-button class="mb-2" variant="primary" @click="selectShortcode('telephone')">Telephone</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div ref="shortcodeCollapseFallback" v-show="selectedShortcode">
          <b-row >
            <b-col>
              <b-form-group class="text-center"
                  label-for="shortcode-fallback"  label="If you want to include a fallback for if the personalisation isn't known, please enter it here. Otherwise leave blank.">
                <b-input id="shortcode-fallback" v-model="selectedShortcodeFallback"></b-input>
                <b-button class="mt-3" variant="primary" @click="insertShortcode(insertElementIndex)">Insert Personalisation</b-button>
              </b-form-group>

            </b-col>
          </b-row>
        </div>
      </b-modal>

      <b-modal v-if="!premiumAccount" ref="advertModal" id="advertModal" size="sm" title="Don't like Ads? No, neither do we!"  :hide-header="true" :hide-footer="true">
        <h4 class="text-center">Remove the Ads</h4>
        <p class="text-center">Upgrade to remove those pesky ads from the bottom of your SizzleDeck.</p>
        <div class="text-center"><a target="_blank" href="/payment" class="btn btn-green">Upgrade to Pro</a></div>
        <div class="text-center mt-4"><small><a class="text-muted" href="javascript:;" @click="hideUpgradeDialog();">Maybe later</a></small></div>
      </b-modal>

    </div>
  </div>

</template>

<script>
  import axios from 'axios';
  import Noty from 'noty';

  import RenderHtml from "./RenderHtml.vue";

  /* FLICKING */
  import { Flicking } from "@egjs/vue-flicking";
  import { Component, Vue } from "vue-property-decorator";
  import { Fade, AutoPlay } from "@egjs/flicking-plugins";

  /* Thumbnails */
  import html2canvas from 'html2canvas';

    export default {
        mounted() {
          var vm = this;

          vm.getAdvert();

          if(vm.deckId){
            vm.initBuilder();
          }else{

            vm.getDeckDefaults();


            

            /*
            vm.blocksNavActive=false;
            vm.getDeckDefaults();
            vm.getTemplates();
            vm.$refs['set-deckname-modal'].show();
            */
          }

        },
        updated(){
 
        },
        components: {
          Flicking: Flicking,
          rendered: RenderHtml,
        },
        props: {
            id: [String, Number],
            premiumAccount:{
              type: [String, Boolean],
              default: false
            },
        },
        data: function(){

            return {
              deckId: this.id,
              deckName: 'Untitled',

              cards:[],

              // Popout of CardElementTemplates eg. Image,Heading,Text,Button etc.
              cardelementtemplatesnav:[],
              cardelementsNavActive: true,
              cardsNavActive: true,

              activeCardIndex: 0,
              activeElementIndex: 0,
              

              deckTemplateName: 'My SizzleDeck Template',
              deckBackground: null,
              deckHeadingFont: null,
              deckBodyFont: null,
              deckAccentColor: null,
              deckSecondaryColor: null,
              deckTertiaryColor: null,
              deckContrastColor: null,
              deckGroundColor: null,
              deckBodySize: null,
              deckHeadingSize: null,
              deckHeadingColor: null,
              deckButtonTextColor: null,
              deckButtonBackgroundColor: null,

              dynamicOgImage: true,
              staticOgImage: null, 

              deckUserProfile: true,
              deckCompanyProfile: true,

              deckProfile: null,
              deckProfileImage: 'none',
              deckProfileBubbleText: 'Check out my profile to find out more:',
              deckProfileBubbleBtnText: 'View Profile',

              swatches: [],

              manageCompanyCards: false,

              deckDefaults: [],
              blocktemplatesnav:[],
              blocksNavActive: true,
              blockSettingsActive: false,
              blockSettingsActiveId: null,
              blockSettingsActiveRef: null,
              blockSettings:[],
              blocks:[],
              
              deckStyle: null,


              
              //activeBlockIndex: 0,
              viewport: 'desktop',

              
              editDeckName: false,
              tempDeckName: false,
              

              updateThumbnail: false, // For Thumbnail Regen

              isTemplate: false,

              isMounted: false, // Important - stops premature or double saving etc.

              newCardPreview: '/images/thumbnails/new-card-blank.png',

              insert: new Vue(), // For inserting shortcodes to tiptap
              insertElementIndex: null, // For inserting shortcodes to tiptap
              selectedShortcode: null, // For inserting shortcodes to tiptap
              selectedShortcodeFallback: null, // For inserting shortcodes to tiptap

              advert: '',
              

            }
        },

        methods: {
         
          launchShortcodeModal: function(elementIndex){

            this.insertElementIndex = elementIndex;

            this.selectedShortcode = null;
            this.selectedShortcodeFallback = null;

            this.$refs['shortcodeModal'].show();

          },
          selectShortcode: function(shortcode){

            this.selectedShortcode = shortcode;
            this.selectedShortcodeFallback = null;

          },
          insertShortcode: function(elementIndex){

            this.$refs['shortcodeModal'].hide();

            var fallback = '';
            if(this.selectedShortcodeFallback){
              fallback = ", fallback='"+this.selectedShortcodeFallback+"'";
            }

            var insertData = '['+this.selectedShortcode+fallback+']';

            this.insert.$emit('shortcode', {
                  elementIndex: elementIndex,
                  data: insertData,
            });

            this.selectedShortcode = null;
            this.selectedShortcodeFallback = null;

          },

          initBuilder: async function(){

            var vm = this;
            
            vm.getDeckSettings();

            // AutoSave            
            //setInterval(function(){ vm.saveDeck('autosave');}, 300000);

          },

          toggleEditDeckName: async function(){
            var vm = this;
            vm.editDeckName = !vm.editDeckName;
            vm.tempDeckName = vm.deckName;
            if(vm.tempDeckName == 'Untitled'){vm.tempDeckName = '';}
            await vm.$nextTick();
            vm.$refs.tempDeckName.focus();
          },
          confirmDeckName: function(){
            var vm = this;
            if(vm.tempDeckName.trim() !== ''){
              vm.deckName = vm.tempDeckName;
              vm.saveDeck();
            }
            vm.editDeckName = !vm.editDeckName;
          },
          discardDeckName: function(){
            var vm = this;
            vm.editDeckName = !vm.editDeckName;
          },

          getDeckSettings: function(){

            var vm = this;

            axios.get('/deck/settings/'+this.deckId).then(response => {

              if(response.data.name){vm.deckName = response.data.name;}
              if(response.data.background){vm.deckBackground = response.data.background;}

              if(response.data.show_profile !== null){vm.deckUserProfile = response.data.show_profile;}
              if(response.data.show_company_profile !== null){vm.deckCompanyProfile = response.data.show_company_profile;}
              if(response.data.deck_style){vm.deckStyle = response.data.deck_style;}


              if(response.data.show_combined_profile !== null){vm.deckProfile = response.data.show_combined_profile;}
              if(response.data.combined_profile_bubble_image !== null){vm.deckProfileImage = response.data.combined_profile_bubble_image;}
              if(response.data.combined_profile_bubble_text !== null){vm.deckProfileBubbleText = response.data.combined_profile_bubble_text;}
              if(response.data.combined_profile_bubble_btn_text !== null){vm.deckProfileBubbleBtnText = response.data.combined_profile_bubble_btn_text;}



              if(response.data.og_image_static){vm.staticOgImage = response.data.og_image_static; vm.dynamicOgImage=false;}
              if(response.data.status == 'template'){
                vm.isTemplate = true;
              }

              vm.getDeckDefaults();

            }).catch(() => console.warn('Oh. Something went wrong. getDeckSettings'));

          },
          getDeckDefaults: function(){
            var vm = this;

            console.log('getDeckDefaults');
            axios.get('/deck/defaults').then(response => {

              vm.deckDefaults = response.data;

              if(vm.deckBackground == null){      vm.deckBackground = response.data.background; }
              if(vm.deckHeadingFont == null){     vm.deckHeadingFont = response.data.heading_font; }
              if(vm.deckBodyFont == null){        vm.deckBodyFont = response.data.body_font; }
              if(vm.deckAccentColor == null){     vm.deckAccentColor = response.data.accent_color;}
              if(vm.deckSecondaryColor == null){  vm.deckSecondaryColor = response.data.secondary_color; }
              if(vm.deckTertiaryColor == null){   vm.deckTertiaryColor = response.data.tertiary_color; }
              if(vm.deckContrastColor == null){   vm.deckContrastColor = response.data.contrast_color; }
              if(vm.deckGroundColor == null){     vm.deckGroundColor = response.data.ground_color; }
              if(vm.deckBodySize == null){        vm.deckBodySize = response.data.body_size; }
              if(vm.deckHeadingSize == null){     vm.deckHeadingSize = response.data.heading_size; }
              if(vm.deckHeadingColor == null){     vm.deckHeadingColor = response.data.heading_color; }
              if(vm.deckButtonTextColor == null){     vm.deckButtonTextColor = response.data.button_text_color; }
              if(vm.deckButtonBackgroundColor == null){     vm.deckButtonBackgroundColor = response.data.button_background_color; }

              if(vm.deckUserProfile == null){     vm.deckUserProfile = response.data.show_profile; }
              if(vm.deckCompanyProfile == null){     vm.deckCompanyProfile = response.data.show_company_profile; }
              if(vm.deckStyle == null){     vm.deckStyle = response.data.deck_style; }


              if(vm.deckProfileImage == null){     vm.deckProfileImage = response.data.combined_profile_bubble_image; }
              if(vm.deckProfileBubbleText == null){     vm.deckProfileBubbleText = response.data.combined_profile_bubble_text; }
              if(vm.deckProfileBubbleBtnText == null){     vm.deckProfileBubbleBtnText = response.data.combined_profile_bubble_btn_text; }


              vm.swatches = [];
              vm.swatches.push(vm.deckAccentColor);
              if(vm.deckSecondaryColor !== vm.deckAccentColor){ vm.swatches.push(vm.deckSecondaryColor); }
              if(vm.deckTertiaryColor !== vm.deckAccentColor && vm.deckTertiaryColor !== vm.deckSecondaryColor){ vm.swatches.push(vm.deckTertiaryColor); }
              vm.swatches.push(vm.deckContrastColor);
              vm.swatches.push(vm.deckGroundColor);

              
              vm.getCardelementTemplates();

            }).catch(() => console.warn('Oh. Something went wrong. getDeckDefaults'));

          },


          /* Card Element Templates */
          getCardelementTemplates: function(){

            console.log('getCardelementTemplates');

            const url = `/deck/cardelement-templates`;
            var vm = this;
            axios.get(url).then(response => {

                vm.cardelementtemplatesnav = response.data;      

                vm.getCards();

            }).catch(() => console.warn('Oh. Something went wrong. getCardelementTemplates'));

          },

          getCards: async function(argument) {

              console.log('getCards');

              if(!this.deckId){ this.addNewCard(); this.isMounted = true; return; } // If new deck

              const url = `/deck/`+ this.deckId +`/cards`;

              var vm = this;

              axios.get(url).then(response => {

                if(response.data.length > 0){                

                response.data.forEach(function(card){

                  var elements = []; 
                  card.cardelements.forEach(function(cardelement){

                    var element = {
                      id: cardelement.id,
                      template_cardelement_id: cardelement.template_cardelement_id,
                      type: cardelement.card_element_template.editable.type,
                      content: JSON.parse(cardelement.content),
                      html: cardelement.card_element_template.html,
                      reference: cardelement.card_element_template.editable.reference,
                    }

                    elements.push(element);
                  });

                var newcard = {
                    html: '',
                    content: JSON.parse(card.content), // card settings: padding, background etc.
                    elements: elements,
                };

                newcard.html = vm.parseHTML(newcard); // This is what we grab when we output on preview/display
                  
                  vm.cards.push(newcard);

                });

              }

                Vue.nextTick(function(){


                  // TODO: find a better way than waiting for a timeout
                  setTimeout(()=>{vm.flickingResetHeight(vm.activeCardIndex);}, 600);

                  vm.isMounted = true;

                });

              }).then(function(){

                setTimeout(()=>{

                vm.cards.forEach(function(card,i) {
                  if(!card.content.hasOwnProperty('thumbnail')){

                    vm.saveCardThumbnail(i);
                  }
                  
                })

                }, 600);

              }).catch(() => console.warn('Oh. Something went wrong. getCards'));




          },
          saveCardThumbnail: function(cardIndex){
                
              var vm = this;

              vm.saveDeck('silent'); // too many notifications!

              var source = vm.$refs['card['+cardIndex+']'][0].querySelector('.sd-block');

              source.classList.add("screenshot-in-progress");

              html2canvas(source,{}).then(function(canvas){
                const url = `/deck/save-card-thumbnail`;
                var thumbnail = canvas.toDataURL("image/png");
                var oldThumbnail = null;
                if(vm.cards[cardIndex].content.hasOwnProperty('thumbnail')){
                  oldThumbnail = vm.cards[cardIndex].content.thumbnail.file;  
                }
                

                axios.post(url,{'thumbnail':thumbnail,'old_thumbnail':oldThumbnail,'deck_id':vm.deckId,'card_index':cardIndex}).then(response => {

                  Vue.set(vm.cards[cardIndex].content,'thumbnail',response.data);
                  source.classList.remove("screenshot-in-progress");

                });

              });

          },
          saveDeck: function(event){

            var vm = this;

            if(!vm.isMounted){return;} // Stops double saving!

            if(!vm.deckId){
              var url = `/deck/new`;
            }else{
              var url = `/deck/`+ vm.deckId +`/save`;
            }

            if(event == 'preview'){
              var previewWindow = window.open("", 'sd_preview');       

              if(!previewWindow || previewWindow.closed || typeof previewWindow.closed=='undefined') 
              { 
                  new Noty({
                        text: 'Hmmmmm - looks like your browser security settings has stopped the preview window from opening. Please change your browser settings to allow popups for this site.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 20000
                    }).show();
              }

            }

            axios.post(url,{'name':vm.deckName,'cards':vm.cards}).then(response => {

              if(!response.data.status || response.data.status !== 'success'){
                  new Noty({
                        text: 'There has been an error, please try saving again.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

              }else{
                    
                    if(!vm.deckId){
                      vm.deckId = response.data.deck_id;
                      window.history.pushState("", "", "/deck/edit/"+response.data.deck_id);
                    }

                    if(!(event == 'silent' || event == 'make-template')){

                      new Noty({
                          text: response.data.message,
                          type: response.data.status,
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 1000
                      }).show();

                    }
                    

                    if(event == 'send'){
                      window.location.href = "/deck/send/"+ vm.deckId;
                    }
                    if(event == 'make-template'){
                      vm.convertToTemplate();
                    }
                    if(event == 'close-template'){
                      window.location.href = "/deck/published";
                    }
                    if(event == 'close-draft'){
                      window.location.href = "/deck/drafts";
                    }
                    if(event == 'preview'){
                      window.open("/deck/preview/"+ vm.deckId, 'sd_preview');
                    }

              }
              
              return 'Saved';

            });

          },
          cloneCardElement: function(cardElementTemplate){

            var vm = this;

            

            // If no social links are set, then notify user don't add social element
            if(cardElementTemplate.editable.type == 'socialbar'){
            	if( !vm.deckDefaults["social-facebook"] &&
            		!vm.deckDefaults["social-twitter"] &&
            		!vm.deckDefaults["social-instagram"] &&
            		!vm.deckDefaults["social-linkedin"] ){

	            	new Noty({
	                        text: 'Looks like you need to add your social links. Please visit <a href="/deck/settings#profile-card">Deck Settings</a> to set these up.',
	                        type: 'error',
	                        theme: 'bootstrap-v4',
	                        layout: 'topCenter',
	                        timeout: 20000
                    }).show();

            		return false;
            	}

            }


            // If logo image but no logo is set
            
            if(cardElementTemplate.editable.type == 'image' && cardElementTemplate.editable.content.src == '{company-logo}'){
            	console.log(vm.deckDefaults.logo);
            	if(vm.deckDefaults.logo.includes('/images/default/placeholder-logo.png')){

	            	new Noty({
	                        text: 'Looks like you have not added a logo. Please visit <a href="/deck/settings#images-backgrounds">Deck Settings</a> to set this up.',
	                        type: 'error',
	                        theme: 'bootstrap-v4',
	                        layout: 'topCenter',
	                        timeout: 20000
                    }).show();

            		return false;
            	}
            } 


            // Convert CardElementTemplate into cardElement
            var cardElement = {
              id: null,
              template_cardelement_id : cardElementTemplate.id,
              type: cardElementTemplate.editable.type,
              label: cardElementTemplate.editable.label,

              /* Note: Using JSON.stringify / parse to ensure 'deep' copy */
              content: JSON.parse(JSON.stringify(cardElementTemplate.editable.content,(key, value) => {
  				    if(value == ""){ return null; } // Set "" to null
  				      return value;
				      })),
              html: cardElementTemplate.html,
              reference: cardElementTemplate.editable.reference,
            };

            return cardElement;

          },

          addCardElement: async function(cardElementTemplate){

            var vm = this;

            var cardElement = vm.cloneCardElement(cardElementTemplate);

            // If card element hasn't been cloned (eg. no logo set)
            if(cardElement == false){ return false; }

            if(!vm.cards[vm.activeCardIndex]){
              vm.addNewCard();
            }

            vm.cards[vm.activeCardIndex].elements.push(cardElement);
            vm.updateThumbnail=true;

            await this.$nextTick();
            vm.flickingResetHeight(vm.activeCardIndex);
            vm.flickingBottom();
          },

          parseHTML: function(parentitem){
            
            var vm = this;

            // If Card Element
            if(parentitem.hasOwnProperty('template_cardelement_id')){

              // If card element
              var cardHtml = $('<div></div>').append(parentitem.html); // Create a holder div for jQuery to work from.

              var cardElements = [parentitem]; // Put in array so forEach works

            }else{

                  // If card has block template (ie. v1 card) - shouldn't be required but just in case...
                  if(parentitem.hasOwnProperty('block_template')){

                    // Insert content
                    var cardHtml = $('<div></div>').append(parentitem.block_template.html); // Create a holder div for jQuery to work from.
                    var cardElements = JSON.parse(parentitem.content);

                  }else{ // If v2 card - ie normal situation

                  	if(parentitem.content == null){return;} // Incase of cancelled element clone

                    var cardHtml = $('<div></div>'); // Create a holder div for jQuery to work from.

                    var cardWrapper = $('<div class="sd-block skin-light p-'+parentitem.content.padding+'" data-reference="background" style="background-color: '+parentitem.content.backgroundColor+';"></div>'); // Card element with settings

                    var cardElements = parentitem.elements; // Grab the card elements

                    cardElements.forEach(function(item, index){
                      cardWrapper = cardWrapper.append(item.html); // pop elements in holder
                    });

                    cardHtml = cardHtml.append(cardWrapper); // add holder to card :)

                  }

            }

                  
            cardElements.forEach(function(item, index){

                    if(item.type == 'heading' ){
                      
                      var wrapper = null;
                      wrapper = $(document.createElement(item.content.wrapper)); // Create heading tag
                      wrapper.html(item.content.html); // Fill with content
                      var heading = cardHtml.find('[data-reference="' + item.reference + '"]:first'); // Find Ref in HTML
                      heading.html(wrapper); // Inject Heading
                      heading.addClass('px-'+item.content.paddingSides);
                      heading.addClass('pt-'+item.content.paddingTop);
                      heading.addClass('pb-'+item.content.paddingBottom);
                      heading.addClass('text-'+item.content.textAlign);
                      heading.addClass('font-family-'+item.content.font);
                      heading.addClass('force-heading-size-'+item.content.fontSize);
                      heading.attr('data-reference',item.reference+'-DONE'); // Mark Ref as done.
                      
                    }
                    if(item.type == 'text' ){
                      
                      var text = cardHtml.find('[data-reference="' + item.reference + '"]:first'); // Find Ref in HTML
                      text.html(item.content.html);
                      text.addClass('px-'+item.content.paddingSides);
                      text.addClass('pt-'+item.content.paddingTop);
                      text.addClass('pb-'+item.content.paddingBottom);
                      text.addClass('text-'+item.content.textAlign);
                      text.addClass('font-family-'+item.content.font);
                      text.addClass('force-body-size-'+item.content.fontSize);
                      text.attr('data-reference',item.reference+'-DONE'); // Mark Ref as done.
                      
                    }
                    if(item.type == 'image' ){
            
                      var imageElement = cardHtml.find('[data-reference="' + item.reference + '"]:first');
                      var image = imageElement.find('img');


                      if(item.content.src == '{company-logo}'){
                        item.content.src = vm.deckDefaults.logo;
                      }
                      if(item.content.src == '{avatar}'){
                        item.content.src = vm.deckDefaults.profile_pic;
                      }


                      image.attr('src',item.content.src);

                      if(item.content.hasOwnProperty('href') && item.content.href !== '' && item.content.href !== null){
                        //image.wrap('<a href="'+item.content.href+'" target="_blank"></a>');
                        image.wrap('<span title="Image Link: '+item.content.href+'"></span>');
                      }


                      
                      imageElement.addClass(item.content.align);
                      
                      image.addClass(item.content.corners);

                      if(item.content.corners == 'rounded-circle'){
                        imageElement.addClass('rounded-circle-wrap');
                        imageElement.addClass(item.content.width);

                        if(item.content.hasOwnProperty('marginSides')){
                          imageElement.addClass('mx-'+item.content.marginSides);
                        }
                        if(item.content.hasOwnProperty('marginTop')){
                          imageElement.addClass('mt-'+item.content.marginTop);
                        }
                        if(item.content.hasOwnProperty('marginBottom')){
                          imageElement.addClass('mb-'+item.content.marginBottom);
                        }
                        
                        if(item.content.hasOwnProperty('paddingSides')){
                          imageElement.addClass('mx-'+item.content.paddingSides);
                        }
                        if(item.content.hasOwnProperty('paddingTop')){
                          imageElement.addClass('mt-'+item.content.paddingTop);
                        }
                        if(item.content.hasOwnProperty('paddingBottom')){
                          imageElement.addClass('mb-'+item.content.paddingBottom);
                        }

                      }else{
                        image.addClass(item.content.width);

                        /**/
                        if(item.content.hasOwnProperty('marginSides')){
                          imageElement.addClass('mx-'+item.content.marginSides);
                        }
                        if(item.content.hasOwnProperty('marginTop')){
                          imageElement.addClass('mt-'+item.content.marginTop);
                        }
                        if(item.content.hasOwnProperty('marginBottom')){
                          imageElement.addClass('mb-'+item.content.marginBottom);
                        }
                        
                        if(item.content.hasOwnProperty('paddingSides')){
                          imageElement.addClass('px-'+item.content.paddingSides);
                        }
                        if(item.content.hasOwnProperty('paddingTop')){
                          imageElement.addClass('pt-'+item.content.paddingTop);
                        }
                        if(item.content.hasOwnProperty('paddingBottom')){
                          imageElement.addClass('pb-'+item.content.paddingBottom);
                        }
                        /**/

                      }


                      imageElement.attr('data-reference',item.reference+'-DONE');
                    }

                    if(item.type == 'video' ){
                      
                      var videoElement = cardHtml.find('[data-reference="' + item.reference + '"]:first');
                      var videoWrapper = videoElement.find('.video-iframe-wrapper:first');
                      var videoIframe = videoWrapper.find('iframe:first');

                      videoIframe.attr('src',item.content.src);

                      videoElement.addClass('px-'+item.content.paddingSides);
                      videoElement.addClass('pt-'+item.content.paddingTop);
                      videoElement.addClass('pb-'+item.content.paddingBottom);

                      var videoWidth = item.content.width;
                      var videoHeight = item.content.height;

                      var paddingBottom = (videoHeight / videoWidth)*100+"%";

                      videoWrapper.css('padding-bottom',paddingBottom);

                      videoElement.attr('data-reference',item.reference+'-DONE');
                      
                    }

                    if(item.type == 'spacer' ){
                      
                      var text = cardHtml.find('[data-reference="' + item.reference + '"]:first'); // Find Ref in HTML
                      text.addClass('pb-'+item.content.paddingBottom);
                      text.attr('data-reference',item.reference+'-DONE'); // Mark Ref as done.
                      
                    }

                    if(item.type == 'button' ){

                      var button = cardHtml.find('[data-reference="' + item.reference + '"]:first'); // Find Ref in HTML
                      button.html(item.content.html);


                      if(item.content.hasOwnProperty('link')){
                        button.attr('href',item.content.link.prefix + item.content.link.url);
                      }
                      if(item.content.hasOwnProperty('href')){
                        button.attr('href',item.content.href);
                      }
                      

                      if(item.content.buttonColor !== null && item.content.buttonColor !== ''){
                        button.css('background-color',item.content.buttonColor);
                      }

                      if(item.content.textColor !== null && item.content.textColor !== ''){
                        button.css('color',item.content.textColor);
                      }

                      button.addClass('btn-'+item.content.size);
                      button.addClass('mx-'+item.content.marginSides);
                      button.addClass('mt-'+item.content.marginTop);
                      button.addClass('mb-'+item.content.marginBottom);
                      button.addClass('font-family-'+item.content.font);
                      button.attr('data-reference',item.reference+'-DONE');

                    }

                    if(item.type == 'socialbar' ){

                      var bar = cardHtml.find('[data-reference="' + item.reference + '"]:first'); // Find Ref in HTML
                      bar.html(item.content.html);

                      if(item.content.twitter == '{social-twitter}'){
                        item.content.twitter = vm.deckDefaults['social-twitter'];
                      }
                      if(item.content.instagram == '{social-instagram}'){
                        item.content.instagram = vm.deckDefaults['social-instagram'];
                      }
                      if(item.content.linkedin == '{social-linkedin}'){
                        item.content.linkedin = vm.deckDefaults['social-linkedin'];
                      }
                      if(item.content.facebook == '{social-facebook}'){
                        item.content.facebook = vm.deckDefaults['social-facebook'];
                      }

                      bar.find('[data-reference="twitter"]:first').attr('href',item.content.twitter);
                      bar.find('[data-reference="instagram"]:first').attr('href',item.content.instagram);
                      bar.find('[data-reference="linkedin"]:first').attr('href',item.content.linkedin);
                      bar.find('[data-reference="facebook"]:first').attr('href',item.content.facebook);



                      
                      if(item.content.twitter){
                        bar.find('[data-reference="twitter"]:first').addClass('d-inline-block');
                      }else{
                        bar.find('[data-reference="twitter"]:first').addClass('d-none');
                      }
                      
                      if(item.content.instagram){
                        bar.find('[data-reference="instagram"]:first').addClass('d-inline-block');
                      }else{
                        bar.find('[data-reference="instagram"]:first').addClass('d-none');
                      }
                      
                      if(item.content.linkedin){
                        bar.find('[data-reference="linkedin"]:first').addClass('d-inline-block');
                      }else{
                        bar.find('[data-reference="linkedin"]:first').addClass('d-none');
                      }
                      
                      if(item.content.facebook){
                        bar.find('[data-reference="facebook"]:first').addClass('d-inline-block');
                      }else{
                        bar.find('[data-reference="facebook"]:first').addClass('d-none');
                      }
                      
                      
                      
                      if(item.content.buttonColor !== null && item.content.buttonColor !== ''){
                        bar.find('.social-icon').css('background-color',item.content.buttonColor);
                      }

                      if(item.content.textColor !== null && item.content.textColor !== ''){
                        bar.find('.social-icon').css('color',item.content.textColor);
                      }

                      bar.addClass('text-'+item.content.textAlign);

                      bar.addClass('social-btn-size-'+item.content.size);

                      bar.addClass('mx-'+item.content.marginSides);
                      bar.addClass('mt-'+item.content.marginTop);
                      bar.addClass('mb-'+item.content.marginBottom);

                      bar.attr('data-reference',item.reference+'-DONE');

                    }

            


                  });

                  if(!vm.premiumAccount){
                  
                    cardHtml.find('.sd-block').append(vm.advert);

                  }

            return cardHtml.html();

          },
          toggleCardElementActive: function(cardElementIndex){
            let keys = []
            var vm = this;
            for (let [key, value] of Object.entries(vm.$refs)) {
              if (/^cardElement_/.test(key)) {
                  
                  	if(vm.$refs[key][0] !== undefined){ // Check element hasn't been deleted
						vm.$refs[key][0].classList.remove('focused');
                  	}
                  
              }
            }
            if(vm.$refs['cardElement_'+cardElementIndex][0] !== undefined){// Check element hasn't been deleted
            	vm.$refs['cardElement_'+cardElementIndex][0].classList.add('focused');
        	}
          },       
          openElementSettings: function(elementIndex){
            
            this.activeElementIndex = elementIndex;
            this.$refs['activeElementSettings'].show();

          },
          setImageSize:function(elementIndex,currentWidth,direction){

            var currentWidth = currentWidth.replace('w-','');
            currentWidth = Number.parseInt(currentWidth);

            if(direction == 'increase'){
              currentWidth = currentWidth + 5;
            }else{
              currentWidth = currentWidth - 5;
            }            

            if(currentWidth > 100){currentWidth = 100;}
            if(currentWidth < 5){currentWidth = 5;}

            this.setElementSetting(elementIndex,'width','w-'+currentWidth)
            
          },
          decreaseImageSize:function(elementIndex,currentWidth){
            //elementIndex,'width','w-75'
            this.setElementSetting(elementIndex,'width','w-75')

          },
          setElementSetting: function(elementIndex,attr,val){
            Vue.set(this.cards[this.activeCardIndex].elements[elementIndex].content,attr,val);
            this.flickingResetHeight(this.activeCardIndex);
          },
          removeElement: function(index){
            var vm = this;            
            vm.cards[vm.activeCardIndex].elements.splice(index, 1);
            vm.updateThumbnail=true;
            this.flickingResetHeight(this.activeCardIndex);
            return;
          },
          duplicateElement: function(index){
            var vm = this;      

            var clonedElement = JSON.parse(JSON.stringify(vm.cards[vm.activeCardIndex].elements[index]));

            vm.cards[vm.activeCardIndex].elements.splice(index, 0,clonedElement)

            vm.updateThumbnail=true;
            this.flickingResetHeight(this.activeCardIndex);
            return;
          },

          moveElementUp: function(index){
            var vm = this;            

            if(index == 0){ return;} // if already first element

            var element = vm.cards[vm.activeCardIndex].elements[index];
            var swapElement = vm.cards[vm.activeCardIndex].elements[index - 1];

            var elements = vm.cards[vm.activeCardIndex].elements;
            //vm.cards[vm.activeCardIndex] = [];
            elements.splice(index,1,swapElement);
            elements.splice(index - 1,1,element);

            vm.updateThumbnail=true;
            this.flickingResetHeight(this.activeCardIndex);
            return;
          },
          moveElementDown: function(index){
            var vm = this;            

            console.log('length',vm.cards[vm.activeCardIndex].elements.length);
            console.log('index',index);

            if(index == (vm.cards[vm.activeCardIndex].elements.length - 1) ){ return;} // if already last element

            var element = vm.cards[vm.activeCardIndex].elements[index];
            var swapElement = vm.cards[vm.activeCardIndex].elements[index + 1];

            var elements = vm.cards[vm.activeCardIndex].elements;
            //vm.cards[vm.activeCardIndex] = [];
            elements.splice(index,1,swapElement);
            elements.splice(index + 1,1,element);

            vm.updateThumbnail=true;
            this.flickingResetHeight(this.activeCardIndex);
            return;
          },
          launchSelectDeckBackground: function(){
            this.$refs['choose-background-modal'].show();
          },

          launchSelectImage: function(elementIndex){
            
            this.activeElementIndex = elementIndex;
            this.$refs['modal-medialib'].show();
          },

          launchOgImagePop: function(e){
              this.$refs['choose-ogimage-modal'].show();
          },

          setDeckOgImage: function(image){

            const url = `/deck/store`;

            axios.post(url,{id:this.deckId,og_image_static:image.src}).then(response => {
               this.staticOgImage = response.data.payload.og_image_static; //image.src;
               this.$refs['choose-ogimage-modal'].hide();
            }).catch(() => console.warn('Oh. Something went wrong with setDeckOgImage'));

          },

          replaceDeckBackground: function(data){

            var vm = this;
            const url = `/deck/store`;

            axios.post(url,{id:vm.deckId,background:data.src}).then(response => {
              console.log(response);
               vm.deckBackground = response.data.payload.background;
            }).catch(() => console.warn('Oh. Something went wrong with replaceDeckBackground'));
              
            vm.$refs['choose-background-modal'].hide();
          },

          replaceImage: function(data){
            this.cards[this.activeCardIndex].elements[this.activeElementIndex].content.src = data.src;
            this.flickingResetHeight(this.activeCardIndex);
            this.updateThumbnail = true;
            this.$refs['modal-medialib'].hide();
          },

          replaceVideo: function(){

            var vm = this;

            var videoUrl = vm.$refs.videoUrl.value;

            var videoType = false;
            
            // First, check for youtube video            
            var videoID = videoUrl.match(/(?:http(?:s|):|)\/\/(?:www\.|)yout(?:.*?)\/(?:embed\/|watch.*?v=|)([a-z_A-Z0-9\-]{11})/);

            if (videoID) {
                var videoID = videoID[1];
                videoUrl = 'https://www.youtube.com/embed/'+videoID+'/?rel=0'; // Format for YT embed URL
                videoType = 'youtube';
                vm.cards[vm.activeCardIndex].elements[vm.activeElementIndex].content.src = videoUrl; // Set Video URL

                new Noty({
                        text: 'YouTube video detected',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                }).show();

            }

            // Then check for Vimeo
            if(!videoType){
              videoID = videoUrl.match(/(?:https?:\/\/)?(?:www.)?(?:player.)?vimeo.com\/(?:[a-z]*\/)*([0-9]{6,11})[?]?.*/);
              if (videoID) {
                  var videoID = videoID[1];
                  var newVideoUrl = 'https://player.vimeo.com/video/'+videoID+'?title=0&byline=0&portrait=0'; // Format for Vimeo embed URL
                  videoType = 'vimeo';

                  var matches = videoUrl.match(/^https?:\/\/(www\.)?vimeo.com\/(channels\/[a-zA-Z0-9]*\/)?(?<id>[0-9]*)(\/(?<hash>[a-zA-Z0-9]+))?(\#t=(\d+)s)?/);
                  if (matches && matches.groups.hash) {
                    newVideoUrl = newVideoUrl +'&h='+ matches.groups.hash;
                  }else{
                    var matches = videoUrl.match(/^https:\/\/player\.vimeo\.com\/video\/?(?<id>[0-9]*)(\?title=0&byline=0&portrait=0&h=)?(?<hash>[a-zA-Z0-9]*)?/);
                    if (matches && matches.groups.hash) {
                      newVideoUrl = newVideoUrl +'&h='+ matches.groups.hash;
                    }
                  }

                  vm.cards[vm.activeCardIndex].elements[vm.activeElementIndex].content.src = newVideoUrl; // Set Video URL

                new Noty({
                        text: 'Vimeo video detected',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                }).show();

              }
            }
            
            // If neither then show warning message
            if(!videoType){

                  new Noty({
                        text: 'Unknown video format. For best results, please unsure url is either a youtube or vimeo link.',
                        type: 'warning',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

            }

            
            // Get video dimentions from noembed.com
              
            // using jquery ajax as axios has cors issue... todo: fix cors issue!
            $.ajax({
                    url: 'https://noembed.com/embed?url='+videoUrl,
                    type: 'GET',
                    dataType: 'json', // added data type
                    success: (res) => {

                        if(res.hasOwnProperty('width') && res.hasOwnProperty('height')){
                          vm.cards[vm.activeCardIndex].elements[vm.activeElementIndex].content.width = res.width;
                          vm.cards[vm.activeCardIndex].elements[vm.activeElementIndex].content.height = res.height;
                        }
                        
                    }
                });


            /*
            if(videoType == 'vimeo'){

              // using jquery ajax as axios has cors issue... todo: fix cors issue!
              $.ajax({
                    url: 'https://api.vimeo.com/videos/'+videoID+'?access_token='+process.env.MIX_VIMEO_ACCESS_TOKEN,
                    type: 'GET',
                    dataType: 'json', // added data type
                    success: (res) => {

                        if(res.hasOwnProperty('width') && res.hasOwnProperty('height')){
                          vm.cards[vm.activeCardIndex].elements[vm.activeElementIndex].content.width = res.width;
                          vm.cards[vm.activeCardIndex].elements[vm.activeElementIndex].content.height = res.height;
                        }
                        
                    }
                });


            }
            */


            
              
            
              
            

          },

          chooseNewCard: function() {
            this.$refs['new-card-modal'].show();
          },

          changeNewCardPreview: function(card){

            switch(card){
              case 'cover':
                this.newCardPreview = '/images/thumbnails/new-card-cover.png';
              break;
              case 'cta':
                this.newCardPreview = '/images/thumbnails/new-card-cta.png';
              break;
              default:
                this.newCardPreview = '/images/thumbnails/new-card-blank.png';
              break;
            }
            
          },

          addNewCard: async function (card='') {

            var vm = this;

            switch(card){
              case 'cover':
                var padding = 0;
                var backgroundColor = vm.deckGroundColor;
                var html = '<div class=\"sd-block skin-light p-0\" data-reference=\"background\" style=\"background-color: '+backgroundColor+';\"><div data-reference=\"image-DONE\" class=\"mx-0 mt-0 mb-3 text-center\"><img class=\"img-fluid rounded-top w-100\" src=\"/images/default/car-alley.jpg\"></div><div data-reference=\"content-DONE\" class=\"px-3 pt-0 pb-3 text-left font-family- force-heading-size-undefined\"><h1><strong><span style=\"color: #FFFFFF\">Our SizzleDeck</span></strong></h1></div><div data-reference=\"content-DONE\" class=\"px-3 pt-0 pb-4 text-right font-family- force-heading-size-undefined\"><h3><strong><span style=\"color: #FFFFFF\">SizzleDeck</span></strong></h3></div></div>';
                
                var elements = [
                            {
                              "id": null,
                              "template_cardelement_id": 3,//12,
                              "type": "image",
                              "label": "Image",
                              "content": {
                                "src": "/images/default/example_image_landscape.jpg",
                                "href": "",
                                "align": "text-center",
                                "width": "w-100",
                                "corners": "rounded-top",
                                "marginTop": 0,
                                "marginSides": 0,
                                "marginBottom": 3
                              },
                              "html": "<div data-reference=\"image\"><img class=\"img-fluid\" /></div>",
                              "reference": "image"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 1,//10,
                              "type": "heading",
                              "label": "Heading",
                              "content": {
                                "font": null,
                                "html": "<strong><span style=\"color: "+vm.deckContrastColor+"\">Write Your Amazing Deck Title Here</span></strong>",
                                "wrapper": "h1",
                                "textAlign": "left",
                                "paddingTop": 2,
                                "paddingSides": 4,
                                "paddingBottom": 2
                              },
                              "html": "<div data-reference=\"content\"></div>",
                              "reference": "content"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 1,//10,
                              "type": "heading",
                              "content": {
                                "font": null,
                                "html": "<span style=\"color: #A3A3A3\">Our SizzleDeck</span>",
                                "wrapper": "h2",
                                "textAlign": "left",
                                "paddingTop": 0,
                                "paddingSides": 4,
                                "paddingBottom": 3
                              },
                              "html": "<div data-reference=\"content\"></div>",
                              "reference": "content"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 8,//23,
                              "type": "image",
                              "content": {
                                "src": vm.deckDefaults.logo,
                                "href": null,
                                "align": "text-right",
                                "width": "w-25",
                                "corners": "rounded-0",
                                "marginTop": 0,
                                "marginSides": 4,
                                "marginBottom": 4
                              },
                              "html": "<div data-reference=\"image\"><img class=\"img-fluid\" /></div>",
                              "reference": "image"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 5,//19,
                              "type": "spacer",
                              "content": {
                                "paddingBottom": "2"
                              },
                              "html": "<div class=\"spacer\" data-reference=\"spacer\"></div>",
                              "reference": "spacer"
                            }
                          ];
              break;
              case 'intro':
                var padding = 3;
                var html = '<div class="sd-block skin-light p-2" data-reference="background" style="background-color: rgb(255, 255, 255);"></div>';
                var backgroundColor = vm.deckGroundColor;
                var elements = [
                            {
						      "id": null,
						      "template_cardelement_id": 1,//10,
						      "type": "heading",
						      "content": {
						        "font": null,
						        "html": "<strong>Hi [firstname],</strong>",
						        "wrapper": "h2",
						        "fontSize": null,
						        "textAlign": "left",
						        "paddingTop": 2,
						        "paddingSides": 2,
						        "paddingBottom": 2
						      },
						      "html": "<div data-reference=\"content\"></div>",
						      "reference": "content"
						    },
						    {
						      "id": null,
						      "template_cardelement_id": 2,//11,
						      "type": "text",
						      "content": {
						        "font": null,
						        "html": "<p>The path to enlightenment is a long and winding one, but it is a journey that is well worth taking. Along the way, you will encounter many challenges and obstacles, but if you persevere, you will eventually reach your destination. </p>",
						        "fontSize": null,
						        "textAlign": "left",
						        "paddingTop": 2,
						        "paddingSides": 2,
						        "paddingBottom": 2
						      },
						      "html": "<div data-reference=\"content\"></div>",
						      "reference": "content"
						    },
						    {
						      "id": null,
						      "template_cardelement_id": 2,//11,
						      "type": "text",
						      "content": {
						        "font": null,
						        "html": "<p>The first step on the path to enlightenment is to open your mind and heart to the possibility of a higher power. Once you have done this, you can begin to explore different spiritual traditions and teachings. There is no one right way to find enlightenment, so it is important to find what works best for you. </p>",
						        "fontSize": null,
						        "textAlign": "left",
						        "paddingTop": 2,
						        "paddingSides": 2,
						        "paddingBottom": 2
						      },
						      "html": "<div data-reference=\"content\"></div>",
						      "reference": "content"
						    },
						    {
						      "id": null,
						      "template_cardelement_id": 3,//12,
						      "type": "image",
						      "content": {
						        "src": vm.deckDefaults.profile_pic,
						        "href": null,
						        "align": "text-left",
						        "width": "w-25",
						        "corners": "rounded-circle",
						        "marginTop": 2,
						        "marginSides": 2,
						        "marginBottom": 2
						      },
						      "html": "<div data-reference=\"image\"><img class=\"img-fluid\" /></div>",
						      "reference": "image"
						    },
						    {
						      "id": null,
						      "template_cardelement_id": 1,//10,
						      "type": "heading",
						      "content": {
						        "font": null,
						        "html": vm.deckDefaults.first_name + ' ' + vm.deckDefaults.last_name,
						        "wrapper": "h3",
						        "fontSize": null,
						        "textAlign": "left",
						        "paddingTop": 2,
						        "paddingSides": 2,
						        "paddingBottom": 0
						      },
						      "html": "<div data-reference=\"content\"></div>",
						      "reference": "content"
						    },
						    {
						      "id": null,
						      "template_cardelement_id": 2,//11,
						      "type": "text",
						      "content": {
						        "font": null,
						        "html": "<p>"+vm.deckDefaults.position+"<br><strong>"+vm.deckDefaults.company_name+"</strong></p>",
						        "fontSize": null,
						        "textAlign": "left",
						        "paddingTop": 0,
						        "paddingSides": 2,
						        "paddingBottom": 2
						      },
						      "html": "<div data-reference=\"content\"></div>",
						      "reference": "content"
						    }
                          ];
              break;
              case 'cta':
                var padding = 3;
                var html = '<div class="sd-block skin-light p-4" data-reference="background" style="background-color: rgb(255, 255, 255);"></div>';
                var backgroundColor = vm.deckGroundColor;
                var elements = [
                            {
                              "id": null,
                              "template_cardelement_id": 3,//12,
                              "type": "image",
                              "label": "Image",
                              "content": {
                                "src": vm.deckDefaults.profile_pic,
                                "href": "",
                                "align": "text-center",
                                "width": "w-25",
                                "corners": "rounded-circle",
                                "paddingTop": 2,
                                "paddingSides": 2,
                                "paddingBottom": 2
                              },
                              "html": "<div data-reference=\"image\"><img class=\"img-fluid\" /></div>",
                              "reference": "image"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 1,//10,
                              "type": "heading",
                              "label": "Heading",
                              "content": {
                                "font": "",
                                "html": "<strong>Reach Out</strong>",
                                "wrapper": "h2",
                                "textAlign": "center",
                                "paddingTop": 2,
                                "paddingSides": 2,
                                "paddingBottom": 2
                              },
                              "html": "<div data-reference=\"content\"></div>",
                              "reference": "content"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 2,//11,
                              "type": "text",
                              "label": "Text",
                              "content": {
                                "font": "",
                                "html": "<p>If you have any questions or feedback, please reach out below.</p>",
                                "textAlign": "center",
                                "paddingTop": 2,
                                "paddingSides": 2,
                                "paddingBottom": 2
                              },
                              "html": "<div data-reference=\"content\"></div>",
                              "reference": "content"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 6,//20,
                              "type": "button",
                              "label": "Button",
                              "content": {
                                "font": "",
                                "href": "tel:"+vm.deckDefaults.telephone_nospaces,
                                "html": "Call Me",
                                "icon": false,
                                "size": "lg",
                                "outline": false,
                                "marginTop": 2,
                                "textColor": "",
                                "buttonColor": "",
                                "marginSides": 2,
                                "marginBottom": 2
                              },
                              "html": "<a class=\"btn btn-sizzle d-block\" data-reference=\"button\" target=\"_blank\"></a>\r\n",
                              "reference": "button"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 6,//20,
                              "type": "button",
                              "label": "Button",
                              "content": {
                                "font": "",
                                "href": "mailto:"+vm.deckDefaults.email,
                                "html": "Email Me",
                                "icon": false,
                                "size": "lg",
                                "outline": false,
                                "marginTop": 2,
                                "textColor": "",
                                "buttonColor": "",
                                "marginSides": 2,
                                "marginBottom": 2
                              },
                              "html": "<a class=\"btn btn-sizzle d-block\" data-reference=\"button\" target=\"_blank\"></a>\r\n",
                              "reference": "button"
                            },
                            {
                              "id": null,
                              "template_cardelement_id": 6,//20,
                              "type": "button",
                              "label": "Button",
                              "content": {
                                "font": "",
                                "href": vm.deckDefaults.website,
                                "html": "Visit Website",
                                "icon": false,
                                "size": "lg",
                                "outline": false,
                                "marginTop": 2,
                                "textColor": "",
                                "buttonColor": "",
                                "marginSides": 2,
                                "marginBottom": 2
                              },
                              "html": "<a class=\"btn btn-sizzle d-block\" data-reference=\"button\" target=\"_blank\"></a>\r\n",
                              "reference": "button"
                            }
                          ];
              break;
              default:
                var padding = 3;
                var html = '<div class="sd-block skin-light p-3" data-reference="background" style="background-color: rgb(255, 255, 255);"></div>';
                var backgroundColor = vm.deckGroundColor;
                var elements = [];
              break;
            }

            var vm = this;
            vm.cards.push({
              /* Optional Settings */
              html:html,
              content: {
                padding: padding,
                backgroundColor: backgroundColor,
                thumbnail: {
                  url: null,
                  file: null,
                },
              },
              elements: elements
            });

            await vm.$nextTick();

            vm.flickingMoveTo(vm.cards.length - 1); // Move to newly added card
            
            setTimeout(()=>{ vm.flickingResetHeight(vm.cards.length - 1); vm.updateThumbnail=true;}, 150); // fire after dom updates

            this.$refs['new-card-modal'].hide();

          },
          copyCard: async function(index){
            var vm = this;

            var original_card = vm.cards[index];
 
            console.log('original_card',original_card);

            var vm = this;
            
            /* Note: Using JSON.stringify / parse to ensure 'deep' copy */

            vm.cards.push({
              html:original_card.html,
              content: JSON.parse(JSON.stringify(original_card.content)),
              elements: JSON.parse(JSON.stringify(original_card.elements)),
            });


              

            await vm.$nextTick();

            vm.flickingMoveTo(vm.cards.length - 1); // Move to newly added card
            vm.flickingResetHeight(vm.cards.length - 1);
            vm.updateThumbnail=true;
          },
          removeCard:  function(index){
            var vm = this;

            vm.$bvModal.msgBoxConfirm('Are you sure you want to delete this entire card?').then(confirm => {
              if(confirm){
                vm.cards.splice(index,1);
                if(vm.cards.length==0){
                  vm.addNewCard();
                }
              }
              
            })           
   


          },

          openDeckSettings: function() {
            if(this.isMounted){
              this.saveDeck();
            }
            this.$refs['deckSettings'].show();
          },
          openDeckTemplateDialog: function() {
            this.$refs['saveAsDeckTemplate'].show();
          },
          saveAsDeckTemplate: function() {
            if(this.isMounted){
              this.saveDeck('make-template');
            }
            
          },

          openCardSettings: function(){
            this.$refs['activeCardSettings'].show();
          },

          toggleCardelementsNav: function(){             
                this.cardelementsNavActive = !this.cardelementsNavActive;
          },

          toggleCardsNav: function(){             
                this.cardsNavActive = !this.cardsNavActive;
          },


          launchDonePop: function(){
            this.$refs['deck-done-modal'].show();
          },

          convertToTemplate: function(event){

            const url = `/deck/make-template`;

            var vm = this;

            axios.post(url,{id:vm.deckId,name:vm.deckTemplateName,api:true}).then(response => {
                  
                    if(response.data.status == 'success'){

                      //vm.isTemplate = true;

                      if(event == 'close'){                        
                          window.location.href = "/deck/published";
                        
                      }else{

                        new Noty({
                            text: 'Deck Template Saved to Library',
                            type: 'success',
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: 1000
                        }).show();

                      }
                    
                    }else{

                        new Noty({
                            text: response.data.message,
                            type: response.data.status,
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: 1000
                        }).show();

                    }

            }).catch(() => console.warn('Oh. Something went wrong with onConvertToTemplate'));

          },


/* Flicking Functions */

          flickingMoveStart:function(event){

            

            var vm = this;
            vm.startXpos = event.axesEvent.pos.flick;


            if(vm.$refs.blockContainer.clientWidth < 768){ // Mobile
              if(event.currentTarget.index >= 0){ // if not initial load...
                  if((this.$refs['card['+event.currentTarget.index+']'][0].firstChild.offsetHeight + 45 + 20) < window.innerHeight){ // If card is shorter than viewport then set to 100vh
                    event.currentTarget.$el.style.height = 'calc(100vh - 45px)'; 
                  }
              }
            }
            

          },
          flickingMove:function(event){

            var vm = this;

            // Add 'moving' class to viewport
            event.currentTarget.$el.classList.add('moving');

              var aniBlock;
              var aniBlockIndex;
              var currentTargetIndex = event.currentTarget.index;
              var movedXpos = vm.flickingX(event);              

              
              if(movedXpos === 0){ return; } // ie. not moved
            
              // Mobile



              if(vm.$refs.blockContainer.clientWidth < 768){

              var rotateY = 0;
              var rotateX = 0;
              var skewY = 0;
              var opacity = 1; 

                // Moving Left (Next)
                if(0 >= movedXpos){
                    var speed = 0.25;
                    rotateY = (1 - movedXpos) * speed; 
                    rotateX = (1 - movedXpos) * speed; 
                    skewY = (movedXpos / 4)  * speed; 
                    opacity = 1 + ((movedXpos / 60) * speed); 
                    if(opacity < 0){ opacity = 0; }
                    
                    aniBlockIndex = currentTargetIndex;

                    if(vm.$refs['card['+aniBlockIndex+']'] === undefined){ return; } // attempting to move which doesn't exist

                    aniBlock = vm.$refs['card['+aniBlockIndex+']'][0];
                    aniBlock.style.transform = 'rotateY('+rotateY+'deg) rotateX('+rotateX+'deg) skewY('+skewY+'deg)';
                    aniBlock.style.opacity = opacity;
                  
                // Moving Right (Prev)
                }else{
                    var speed = 0.25;
                    rotateY = (240 - movedXpos) * speed; 
                    if(rotateY < 0){ rotateY = 0; }
                    rotateX = (240 - movedXpos) * speed; 
                    if(rotateX < 0){ rotateX = 0; }
                    skewY = (30 - (movedXpos / 4)) * speed;
                    if(skewY < 0){ skewY = 0; }

                    opacity = (movedXpos * speed) / 60; 
                    if(opacity > 1){ opacity = 1; }
                    
                    aniBlockIndex = currentTargetIndex - 1;

                    if(vm.$refs['card['+aniBlockIndex+']'] === undefined){ return; } // attempting to move which doesn't exist

                    aniBlock = vm.$refs['card['+aniBlockIndex+']'][0];
                    aniBlock.style.transform = 'rotateY('+rotateY+'deg) rotateX('+rotateX+'deg) skewY('+skewY+'deg)';
                    aniBlock.style.opacity = opacity;

                }

              // Desktop
              }else{

              var scale = 0;
              var opacity = 1; 
              


                // Moving Left (Next)
                if(0 >= movedXpos){
                    var speed = 0.25;

                    scale = 1 + ((movedXpos / 600) * speed); 
                    if(scale < 0.8){ scale = 0.8; }

                    opacity = 1 + ((movedXpos / 60) * speed); 
                    if(opacity < 0.3){ opacity = 0.3; }

   
                    
                    aniBlockIndex = currentTargetIndex;

                    if(vm.$refs['card['+aniBlockIndex+']'] === undefined){ return; } // attempting to move which doesn't exist

                    aniBlock = vm.$refs['card['+aniBlockIndex+']'][0];
                    aniBlock.style.transform = 'scale('+scale+','+scale+')';
                    aniBlock.style.opacity = opacity;   


                    aniBlockIndex = currentTargetIndex + 1;

                    if(vm.$refs['card['+aniBlockIndex+']'] === undefined){ return; } // attempting to move which doesn't exist

                    aniBlock = vm.$refs['card['+aniBlockIndex+']'][0];
                    aniBlock.style.transform = 'scale('+(0.8+(1-scale))+','+(0.8+(1-scale))+')';
                    aniBlock.style.opacity = 0.3+(1-opacity);

                  
                // Moving Right (Prev)
                }else{
                    var speed = 0.25;

                    scale = 0.8 + (movedXpos * speed) / 600; 
                    if(scale > 1){ scale = 1; }

                    opacity = 0.3 + (movedXpos * speed) / 60; 
                    if(opacity > 1){ opacity = 1; }

                    
                    aniBlockIndex = currentTargetIndex - 1;



                    if(vm.$refs['card['+aniBlockIndex+']'] === undefined){ return; } // attempting to move which doesn't exist

                    aniBlock = vm.$refs['card['+aniBlockIndex+']'][0];
                    
                    aniBlock.style.transform = 'scale('+scale+','+scale+')';
                    aniBlock.style.opacity = opacity;

                    aniBlockIndex = currentTargetIndex;

                    if(vm.$refs['card['+aniBlockIndex+']'] === undefined){ return; } // attempting to move which doesn't exist

                    aniBlock = vm.$refs['card['+aniBlockIndex+']'][0];
                    aniBlock.style.transform = 'scale('+(0.8+(1-scale))+','+(0.8+(1-scale))+')';
                    aniBlock.style.opacity = 0.3+(1-opacity); 

                    

                }

              }
              


            

          },
          flickingMoveEnd:function(event){

            var vm = this;

            // Remove 'moving' class from viewport
            event.currentTarget.$el.classList.remove('moving');

            // Reset Card styles
            Object.entries(vm.$refs).forEach(entry => {
              const [key, value] = entry;
              if(key.startsWith('card[')){
                if(vm.$refs[key][0] !== undefined){
                  vm.$refs[key][0].style.transform = '';
                  vm.$refs[key][0].style.opacity = '';
                }
              };

            });

            
          },
          flickingWillRestore: function(event){


            var vm = this;

            var cardHeight = (100 + vm.$refs['card['+event.index+']'][0].firstChild.offsetHeight);

            if(vm.$refs.blockContainer.clientWidth < 768){ // Mobile

              if((cardHeight + 100) < vm.$refs['deckBuilderContainer'].firstChild.offsetHeight){
                event.currentTarget.$el.style.height = 'calc(100vh - 100px)'
              }else{
                event.currentTarget.$el.style.height = (100 + vm.$refs['card['+event.index+']'][0].firstChild.offsetHeight) + 'px';
              }

            }else{ // Desktop

              if((cardHeight + 300) < vm.$refs['deckBuilderContainer'].firstChild.offsetHeight){
                event.currentTarget.$el.style.height = 'calc(100vh - 300px)'
              }else{
                event.currentTarget.$el.style.height = (320 + vm.$refs['card['+event.index+']'][0].firstChild.offsetHeight) + 'px';
              }

            }

          },
          flickingWillChange: function(event){

            var vm = this;
            
            vm.flickingResetHeight(event.index);

            vm.flickingTop();

            /* Save HTML version for display */      
            vm.cards[vm.activeCardIndex].html = vm.parseHTML(vm.cards[vm.activeCardIndex]);

            /* Save Thumnail */
            if(vm.updateThumbnail){
              vm.saveCardThumbnail(vm.activeCardIndex);
              vm.updateThumbnail = false;
            }
            

          },
          flickingResetHeight: async function(cardIndex){
            var vm = this;
            
            await this.$nextTick();

            /* Adjust container height so cards fit or are vertically aligned - Might need to revisit for dynamic content */
            var cardHeight = (100 + vm.$refs['card['+cardIndex+']'][0].firstChild.offsetHeight);

              if((cardHeight + 10) < vm.$refs['deckBuilderContainer'].scrollHeight){

                var offset = 300;
                if(!vm.cardsNavActive){offset = 100;}

                vm.$refs['flickingDeck'].$el.style.height = 'calc(100vh - '+offset+'px)';
              }else{
                vm.$refs['flickingDeck'].$el.style.height = (cardHeight + 10) + 'px';
              }
          },
          flickingChanged: function(event){

            
            this.activeCardIndex = event.index;

            if(this.$refs['card['+event.index+']'] === undefined){ return; } // attempting to move which doesn't exist

            this.$refs['card['+event.index+']'][0].classList.add("active");

            if(this.$refs['card['+event.prevIndex+']'] === undefined){ return; } // attempting to move which doesn't exist
            this.$refs['card['+event.prevIndex+']'][0].classList.remove("active");

          },
          flickingX:function(event){
            var vm = this;
            var delta = vm.startXpos - event.axesEvent.pos.flick;
            return delta;
          },
          flickingTop: function(){
            this.$refs['deckBuilderContainer'].scrollTo(0,0);
          },
          flickingBottom: function(){
            this.$refs['deckBuilderContainer'].scrollTo(0,this.$refs['deckBuilderContainer'].scrollHeight);
          },

          flickingPrev: function(){
            
            var vm = this;

            if(vm.$refs['flickingDeck'].animating){
              vm.$refs['flickingDeck'].stopAnimation();
              vm.$refs['flickingDeck'].moveTo(vm.$refs['flickingDeck'].index-1,0);
            }else{
              vm.$refs['flickingDeck'].prev();
            }

          },
          flickingNext: function(){

            var vm = this;

            if(vm.$refs['flickingDeck'].animating){
              vm.$refs['flickingDeck'].stopAnimation();
              vm.$refs['flickingDeck'].moveTo(vm.$refs['flickingDeck'].index+1,0);
            }else{
              vm.$refs['flickingDeck'].next();
            }
            
          },

          flickingMoveTo: function(newIndex){

            var vm = this;

            if(vm.$refs['flickingDeck'].animating){
              vm.$refs['flickingDeck'].stopAnimation();
              vm.$refs['flickingDeck'].moveTo(newIndex,0);
            }else{
              vm.$refs['flickingDeck'].moveTo(newIndex,0);
            }
            
          },

          /* End Flicking Functions */

          getAdvert: async function(){
            const url = `/advert`;
            var vm = this;

              axios.get(url).then(response => {

                  vm.advert = response.data;

              }).catch(() => console.warn('Oh. Something went wrong. getAdvert'));


          },

          upgradeDialog: function(e){
            this.saveDeck('silent');
            console.log(e);
            this.$refs['advertModal'].show();
          },
          hideUpgradeDialog: function(){
            this.$refs['advertModal'].hide();
          },


        },
        watch : {

          deckBodyFont: function(){
            $("head").append(this.deckBodyFont.embed);
            $("head").append('<style id="dynamicStyleBodyFont" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleBodyFont");
            newStyleElement.html('#buildArea,.note-editable{font-family:'+this.deckBodyFont["font-family"]+';}');
          },
          deckHeadingFont: function(){
            $("head").append(this.deckHeadingFont.embed);
            $("head").append('<style id="dynamicStyleHeadingFont" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleHeadingFont");
            newStyleElement.html('#buildArea h1,#buildArea h2,#buildArea h3,#buildArea h4,#buildArea h5,#buildArea h6,#buildArea .h1,#buildArea .h2,#buildArea .h3,#buildArea .h4,#buildArea .h5,#buildArea .h6,.note-editable h1,.note-editable h2,.note-editable h3,.note-editable h4,.note-editable h5,.note-editable h6,.note-editable .h1,.note-editable .h2,.note-editable .h3,.note-editable .h4,.note-editable .h5,.note-editable .h6{font-family:'+this.deckHeadingFont["font-family"]+';}');
          },
          deckHeadingColor: function(){
            $("head").append('<style id="dynamicStyleHeadingColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleHeadingColor");
            newStyleElement.html('#buildArea h1,#buildArea h2,#buildArea h3,#buildArea h4,#buildArea h5,#buildArea h6,#buildArea .h1,#buildArea .h2,#buildArea .h3,#buildArea .h4,#buildArea .h5,#buildArea .h6,.note-editable h1,.note-editable h2,.note-editable h3,.note-editable h4,.note-editable h5,.note-editable h6,.note-editable .h1,.note-editable .h2,.note-editable .h3,.note-editable .h4,.note-editable .h5,.note-editable .h6{color:'+this.deckHeadingColor+';}');
          },
          deckAccentColor: function(){
            $("head").append('<style id="dynamicStyleAccentColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleAccentColor");
            newStyleElement.html('#buildArea .accent{color:'+this.deckAccentColor+';}#buildArea .avatar{ border-color:'+this.deckAccentColor+';}#buildArea .border-accent{ border-top-color:'+this.deckAccentColor+';border-left-color:'+this.deckAccentColor+';border-bottom-color:'+this.deckAccentColor+';border-right-color:'+this.deckAccentColor+';}#buildArea .background-accent,#buildArea .sd-block.background-accent{background-color:'+this.deckAccentColor+';}#buildArea a:not(.social-icon,.ground, .btn){color:'+this.deckAccentColor+';}#buildArea .sd-block ul li::before{color:'+this.deckAccentColor+';}#buildArea .sd-block ol li::before{color:'+this.deckAccentColor+';}');
          },
          deckSecondaryColor: function(){
            $("head").append('<style id="dynamicStyleSecondaryColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleSecondaryColor");
            newStyleElement.html('#buildArea .secondary{color:'+this.deckSecondaryColor+';}#buildArea .border-secondary{ border-top-color:'+this.deckSecondaryColor+';border-left-color:'+this.deckSecondaryColor+';border-bottom-color:'+this.deckSecondaryColor+';border-right-color:'+this.deckSecondaryColor+';}#buildArea .background-secondary,#buildArea .sd-block.background-secondary{background-color:'+this.deckSecondaryColor+';}');
          },
          deckTertiaryColor: function(){
            $("head").append('<style id="dynamicStyleTertiaryColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleTertiaryColor");
            newStyleElement.html('#buildArea .tertiary{color:'+this.deckTertiaryColor+';}#buildArea .border-tertiary{ border-top-color:'+this.deckTertiaryColor+';border-left-color:'+this.deckTertiaryColor+';border-bottom-color:'+this.deckTertiaryColor+';border-right-color:'+this.deckTertiaryColor+';}#buildArea .background-tertiary,#buildArea .sd-block.background-tertiary{background-color:'+this.deckTertiaryColor+';}');
          },
          deckContrastColor: function(){
            $("head").append('<style id="dynamicStyleContrastColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleContrastColor");
            newStyleElement.html('#buildArea, #buildArea .sd-block, #buildArea .sd-block.skin-light, #buildArea .contrast{color:'+this.deckContrastColor+';} #buildArea .background-contrast{background-color:'+this.deckContrastColor+';}');
          },
          deckGroundColor: function(){
            $("head").append('<style id="dynamicStyleGroundColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleGroundColor");
            newStyleElement.html('#buildArea .sd-block.skin-dark, #buildArea .ground{color:'+this.deckGroundColor+';}#buildArea .background-ground,#buildArea .sd-block{background-color:'+this.deckGroundColor+';}');
          },

          deckButtonTextColor: function(){
            $("head").append('<style id="dynamicStyleButtonTextColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleButtonTextColor");
            newStyleElement.html(
              '#buildArea .block-nav{ color: '+this.deckButtonTextColor+'; }'+
              '#buildArea .btn-sizzle{ color:'+this.deckButtonTextColor+';}'
              );
          },

          deckButtonBackgroundColor: function(){
            $("head").append('<style id="dynamicStyleButtonBackgroundColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleButtonBackgroundColor");
            newStyleElement.html(
              '#buildArea .block-nav{ background-color: '+this.deckButtonBackgroundColor+'; border-color:'+this.deckButtonBackgroundColor+';}'+
              '#buildArea .btn-sizzle{ background-color:'+this.deckButtonBackgroundColor+'; border-color:'+this.deckButtonBackgroundColor+';}'
              );
          },

          viewport: function(){
          	var vm = this;
          	setTimeout(()=>{vm.flickingResetHeight(vm.activeCardIndex);}, 50);
          },
          cardsNavActive: function(){
          	var vm = this;
          	setTimeout(()=>{vm.flickingResetHeight(vm.activeCardIndex);}, 50);
          },


          deckUserProfile: async function(){
            

            const url = `/deck/store`;
            var vm = this;

            if(vm.isMounted){

              axios.post(url,{id:vm.deckId,show_profile:vm.deckUserProfile}).then(response => {
                
              }).catch(() => console.warn('Oh. Something went wrong saving deckUserProfile'));

            }
              
          },
          deckCompanyProfile: async function(){
            
            const url = `/deck/store`;
            var vm = this;

            if(vm.isMounted){

              axios.post(url,{id:vm.deckId,show_company_profile:vm.deckCompanyProfile}).then(response => {
                
              }).catch(() => console.warn('Oh. Something went wrong saving deckCompanyProfile'));
                
            }
          },


          // Save Combined Profile Options
          deckProfile: async function(){
            
            const url = `/deck/store`;
            var vm = this;

            if(vm.isMounted){

              axios.post(url,{id:vm.deckId,show_combined_profile:vm.deckProfile}).then(response => {
                
              }).catch(() => console.warn('Oh. Something went wrong saving deckProfile'));
                
            }
          },
          deckProfileImage: async function(){
            
            const url = `/deck/store`;
            var vm = this;

            if(vm.isMounted){

              axios.post(url,{id:vm.deckId,combined_profile_bubble_image:vm.deckProfileImage}).then(response => {
                
              }).catch(() => console.warn('Oh. Something went wrong saving deckProfileImage'));
                
            }
          },
          deckProfileBubbleText: async function(){
            
            const url = `/deck/store`;
            var vm = this;

            if(vm.isMounted){

              axios.post(url,{id:vm.deckId,combined_profile_bubble_text:vm.deckProfileBubbleText}).then(response => {
                
              }).catch(() => console.warn('Oh. Something went wrong saving deckProfileBubbleText'));
                
            }
          },
          deckProfileBubbleBtnText: async function(){
            
            const url = `/deck/store`;
            var vm = this;

            if(vm.isMounted){

              axios.post(url,{id:vm.deckId,combined_profile_bubble_btn_text:vm.deckProfileBubbleBtnText}).then(response => {
                
              }).catch(() => console.warn('Oh. Something went wrong saving deckProfileBubbleBtnText'));
                
            }
          },
          // End Save Combined Profile Options


          dynamicOgImage: async function(){
            var vm = this;

            if(vm.isMounted){

              if(vm.dynamicOgImage){
                const url = `/deck/store`;
                axios.post(url,{id:this.deckId,og_image_static:null}).then(response => {
                   this.staticOgImage = null;
                }).catch(() => console.warn('Oh. Something went wrong saving dynamicOgImage'));

              }

            }
          },
          updateThumbnail: function(){

            var vm = this;
            setTimeout(()=>{
              if(vm.updateThumbnail){
                vm.saveCardThumbnail(vm.activeCardIndex);
                vm.updateThumbnail = false;
                vm.flickingResetHeight(vm.activeCardIndex);
              }
            }, 300);

          },

        },
        computed: {

        }
    }
</script>

<style type="text/css">

/* Form Builder */
#deckBuildArea{
  min-height: calc(100vh - 245px);
}

#deckBuilderContainer .draggable-area {
    min-height: 245px;
    background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 5px 8.7px 22px rgba(64, 69, 73, 0.4);
  max-width: 610px;
}
.deck-name {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    position: relative;
}

.deck-builder-container{
  position: relative;
  min-height: calc(100vh - 157px);
  z-index: 20;
  overflow-x: hidden;
}
.deck-builder-container.shift{
  min-height: calc(100vh - 287px);
  
}


.deck-builder-card-navigation-container{
    overflow-x: scroll;
    min-height: 0px;
    position: relative;
    
}
.deck-builder-card-navigation-container:not(.shift){
padding: 0px;
}


  .deck-builder-card-navigation{
    display: flex;
  }

  .deck-builder-card-navigation .card-preview-container,
  .deck-builder-card-navigation .addNewCard{
    width: 75px;
    max-width: 75px;
    min-width: 75px;
    height: 90px;
    border: 2px solid transparent;
    background-color: #ffffff;
    margin-right: 0.5rem;
    background-size: 100% auto;
    padding-right: 1rem;
    cursor: pointer;
    position: relative;
    background-position: top;
    background-repeat: no-repeat;
  }

  .deck-builder-card-navigation .card-preview-container .delete-card{
    position: absolute;
    top: 0;
    right: 0;
  }

  .deck-builder-card-navigation .card-preview-container.active-card .delete-card{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .deck-builder-card-navigation .card-preview-container.active-card{
    border-color: #0016c4;
  }




  .deck-builder-card-navigation .addNewCard{
    border-color:  #ccc;
    border-style: dashed;
    background-color: #fff;
    color: #ccc;
    font-size: 24px;

    line-height: 89px;
    text-align: center;
    padding: 0;
    margin: 0;
  }


 .sd-block-wrapper {
    margin: 10px 15px 10px;
  }

  .block-nav{
    display: none;
  }


  .modal-backdrop.show{
    /*opacity: 0.8;*/
    /*background-color: #ffffff;*/
  }
  .modal-open .sd-header,
  .modal-open .sd-main{
    filter: blur(4px);
    opacity: 0.5;
    transition: filter 0.5s linear, opacity 0.5s linear;
  }

  .modal-content{
    border-radius: 15px;
  }

  .profile-social .btn.rounded-circle{
    width: 38px;
    height: 38px;
  }

  .modal-close-btn{
    width: 38px;
    height: 38px;
    line-height: 38px;
    padding: 0;
    font-size: 1.5rem;
  }

  .company-profile-logo{
    max-width: 260px;
    display: block;
    margin: 0 auto;
  }


  @media (min-width: 786px){

    .sd-block-wrapper {
      display: flex;
      align-items: flex-start;
      margin-top: 50px;
    }

    .block-container.desktop .sd-block-wrapper:not(.active) {
      transform: scale(0.8);
      opacity: 0.3;
    }
    .flicking-viewport.moving{
      overflow: visible;
    }


    .block-nav{
      cursor: pointer;
      display: block;
      /* position: fixed; -- Not used due to cross-os browser scrollbar issues -- */
      position: absolute;
      /* top: calc(50vh + 60px); */
      top: calc(50% + 20px);
      font-size: 40px;
      z-index: 999;
      box-shadow: 5px 5px 4px -2.5px rgba(0, 0, 0, 0.2);
      width: 40px;
      height: 40px;
      line-height: 0.9;
      text-align: center;
      border-radius: 100%;
    }
    .deck-builder-container.shift .block-nav{
      /* top: calc(50vh - 40px); */
      top: calc(50% - 20px);
    }

    .block-nav i{
        position: relative;
        top: -2px;
    }
    .block-nav:hover{
      box-shadow: 2px 2px 4px -2.5px rgba(0, 0, 0, 0.3);
    }
    .block-nav-prev{ 
      left: calc(50% - 400px);
    }
    .block-nav-prev.shift{ 
      /*left: calc(50% - 340px + 200px);*/
      left: calc(50% - 390px);
    }
    .block-nav-prev i{
        left: -2px;
    }
    .block-nav-next{ 
      right: calc(50% - 385px);
    }
    .block-nav-next.shift{ 
      /* right: calc(50% - 340px - 200px);*/
      right: calc(50% - 390px);
    }
    .block-nav-next i{
        left: 2px;
    }
  

  }

  .builder-cardelements-nav{
    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
    height: calc(100vh - 157px);
  }
  .deck-builder-container.shift .builder-cardelements-nav{
    height: calc(100vh - 287px);
  }
  .builder-cardelements-nav .cardelement-preview{
    box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  .deck-builder-container .deckbuilder-build-area,
  .deck-builder-container .block-container{
    height: calc(100vh - 157px);
  }

  .deck-builder-container .block-container{
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    width: calc(100% - 15px);
  }

  .deck-builder-container.shift .deckbuilder-build-area,
  .deck-builder-container.shift .block-container{
    height: calc(100vh - 287px);
  }




.sd-block-wrapper{
  /* border:  1px solid red; */
}


.builder-cardelements-nav{
  overflow-y: scroll;
  max-width: 400px;
  min-width: 0px;
  position: relative;
}

.builder-cardelements-nav .nav{
  margin-top: 20px;
}

.cardelement{
  position: relative;
}



.card-wrapper{ position: relative; }
.card-wrapper .card-controls{
  position: absolute;
  top: -45px;
  right: 0px;
  display: flex;
  gap: 5px;
}

.cardelement:focus{
  box-shadow: inset 0 0 2px 0 rgba(38, 57, 205, 0.5);
  
}

.deckbuilder-build-area .sd-block{
  overflow: visible; /* Hmmmmm....  */
}


.cardelement .element-controls{
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 2px;
  top: 0px;
  color: #212529;
} 
.cardelement .element-controls.left{
  /*left: -15px;*/
  /*left: -85px;*/
  /*left: -55px;*/
  left: -62px;
  padding-right: 30px;
  /*background-color: #ff00ff;*/

}
.cardelement .element-controls.right{
  /*right: -15px;*/
  right: -45px;
  padding-left: 30px;
}
.cardelement .element-controls.toolbar{
  top: -27px;
  justify-content: center;
  flex-direction: row;
  display: none;

  left: 50%;
  transform: translate(-50%, 0);
}
.cardelement.focused .element-controls.toolbar{
  display: flex;
}
.cardelement .element-controls.image-toolbar{
  top: 5px;
  justify-content: center;
  /*text-align: center;*/
  

  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1001;
}

.cardelement .element-controls .element-control.has-sub{
  text-indent: -2px;
}


.cardelement .element-controls .element-control sub{
  bottom: 12px;
  left: 8px;
  font-size: 60%;
}

.cardelement .element-control {
  outline: white;
  background: #fff;
  padding: 5px;
  border-radius: 0.25rem;
  cursor: pointer;
  text-align: center;
  line-height: 1;
  opacity: 0;
  width: 26px;
  height: 26px;
  z-index: 1001;
  border: 1px solid #000;
}
.cardelement .element-control.selected,
.cardelement .element-control.selected:hover{
	background: #ccc;
}
.cardelement .element-control{
  font-size: 14px;
}
.cardelement:hover .element-control,
.cardelement:focus .element-control {
  opacity: 1;
}
.cardelement .element-control:hover {
  opacity: 1;
  background: #f7f7f7;
}
.cardelement .element-controls .lg{
  font-size: 24px;
  width: 36px;
  height: 36px;
  line-height: 24px;
}
.cardelement .element-controls .lg.icon100{
  font-size: 24px;
  line-height: 24px;
}
.cardelement .element-controls .lg.icon75{
  font-size: 18px;
  line-height: 24px;
}
.cardelement .element-controls .lg.icon50{
  font-size: 14px;
  line-height: 24px;
}
.cardelement .element-controls .lg.icon25{
  font-size: 10px;
  line-height: 24px;
}
.cardelement .element-controls .lg.icon12_5{
  font-size: 8px;
  line-height: 20px;
}
.cardelement .element-control.move-element{
  cursor: move;
}




.cardelement .element-control.delete-element .confirm-delete{
  display: none;
}
.cardelement .element-control.delete-element:hover .confirm-delete{
  display: flex;
}
.cardelement .element-control .confirm-delete{
  font-family: Arial;
  top: 0;
  left: 52px;
  z-index: 999;
  border-radius: 0 0.25rem 0.25rem 0;
  line-height: 26px;
  height: 26px;
  padding-left: 8px;
  border: 1px solid #000;
  border-left: 0;
}
.cardelement .element-control .confirm-delete .buttons{
  display: flex;
  margin-left: 5px;
}
.cardelement .element-control .confirm-delete .buttons .btn{
  font-size: 0.96rem;
  line-height: 1;
  border-radius: 0.25rem;
}

.cardelement .element-controls .flex-column .element-control{
  width: 13px;
  height: 13px;
  font-size: 7px;
  text-align: center;
  padding: 0;
  line-height: 12px;
}

.minimiseNav {
  width: 26px;
  height: 26px;
}
.minimiseNav:focus {
  outline: none !important;
  box-shadow: none;
}

.minimiseNav.tab{
	left: 0px;
	z-index: 999;
	top: 10px;
	border: 0;
	border-radius: 0 0.25rem 0.25rem 0;
}
.minimiseNav.tab.shift{
	left: 385px;
}

.deck-builder-card-navigation-container .minimiseNavContainter{
position: fixed;
right: 16px;
z-index: 999;
height: 0px;
padding-left: 30px;
padding-right: 10px;

margin-top: -8px;
}
.deck-builder-card-navigation-container.shift .minimiseNavContainter{
margin-top: 0px;
height: 90px;
background: rgb(247,247,247);
background: linear-gradient(90deg, rgba(247,247,247,0) 0%, rgba(247,247,247,1) 50%);
}

.deck-builder-card-navigation-container .minimiseNav{
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem 0.25rem 0 0;
}

.deck-builder-card-navigation-container .minimiseNav{
	position: relative;
	top: -18px;
}
.deck-builder-card-navigation-container.shift .minimiseNav{
	top: -39px;
}

.builder-cardelements-nav .minimiseNav{
  top: 5px;
  right: 5px;
  padding: 0.2rem 0.5rem
}
.builder-cardelements-nav .minimiseNav.shift{
  right: 7px;
  right: -24px;
}

.active-card-draggable.empty{
  min-height: 150px;
}
.instructions{
position: absolute;
width: 621px;
max-width: calc(100% - 35px);
/*margin: 20px;*/
display: flex;
flex-direction: column;
padding-top: 40px;
padding-bottom: 40px;
margin: 5px 5px;
}
.instructions,.instructions p{
  font-size: 16px !important;
  font-family: Arial, sans-serif !important;
  line-height: 1.2 !important;
}

.sd-block.p-0 .instructions{
  margin: 20px;
}
.sd-block.p-1 .instructions{
  margin: 17px;
}
.sd-block.p-2 .instructions{
  margin: 13px;
}
.sd-block.p-3 .instructions{
  margin: 5px;
}
.sd-block.p-4 .instructions{
  margin: -3px;
}
.sd-block.p-5 .instructions{
  margin: -26px;
}


/* Viewport */
.block-container.desktop{

}
.block-container.mobile{
  /*max-width: 450px;*/
  max-width: 380px;
  
  margin-left: auto;
  margin-right: auto;
}

.deckbuilder-build-area .animation-style-flicking .block-container.mobile .sd-block{
	max-width: 340px;
}
.deckbuilder-build-area .animation-style-flicking .block-container.mobile .block-nav{
	position: fixed;
	top: calc(50% + 30px);
}
.deckbuilder-build-area .animation-style-flicking .block-container.mobile .block-nav-next.shift{
	right: calc(50% - 500px);
}
.deckbuilder-build-area .animation-style-flicking .block-container.mobile .block-nav-prev.shift{
	left: calc(50% - 100px);
}

.deck-builder-container.shift .animation-style-flicking .block-container.mobile .block-nav{
	top: calc(50% - 30px);
}

.deckbuilder-build-area .animation-style-flicking .block-container.desktop .block-nav{
  position: fixed;
}
.deckbuilder-build-area .animation-style-flicking .block-container.desktop .block-nav-next.shift{
  right: calc(50% - 585px);
}
.deckbuilder-build-area .animation-style-flicking .block-container.desktop .block-nav-prev.shift{
  left: calc(50% - 200px);
}

/* Bring Element Controls in a bit for mobile view */
.block-container.mobile .cardelement .element-controls.left{
  left: -36px;
}
.block-container.mobile .cardelement .element-controls.right{
  right: -28px;
}


.screenshot-in-progress.sd-block{
  box-shadow: none;
}


.deckBackgroundThumb{
  max-width: 290px;
  height: 150px;
  cursor: pointer;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  background-size: contain;
}
.viewport-switcher .btn{min-width: 40px;}

.deckbuilder-build-area .sd-block-wrapper.active .spacer{
  box-shadow: inset 0px 0px 1px 1px rgba(0,0,0,0.05);
}
.deckbuilder-build-area .sd-block-wrapper.active .spacer:hover{
  box-shadow: inset 0px 0px 1px 1px rgba(0,22,196,0.1);
}


.deck-builder-card-navigation-container::-webkit-scrollbar,
#deckBuilderContainer ::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    background: #f0f0f0;
}

.deck-builder-card-navigation-container::-webkit-scrollbar-thumb,
#deckBuilderContainer ::-webkit-scrollbar-thumb {
    background: #999;
    -webkit-border-radius: 1ex;
    /* -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);*/
    -webkit-box-shadow: 0px;
}

.deck-builder-card-navigation-container::-webkit-scrollbar-corner,
#deckBuilderContainer ::-webkit-scrollbar-corner {
    background: #000;
}


.viewport-switcher .fa-mobile-phone, 
.viewport-switcher .fa-mobile{
  transform: scale(1.8);
}

.minimiseNav .fa-angle-double-down,
.minimiseNav .fa-angle-double-left{
  font-size: 12px;
  transform: scale(1.2) translateY(-1px);
}


/* New Card Modal */

#new-card-modal .card,
#new-card-modal .card .card-footer{
  background: none;
  border: none;
  box-shadow: none;
}
#new-card-modal .card .card-footer{
	padding-top: 0;
	padding-left: 0;
	padding-right: 0;
}

#new-card-modal .card .card-img-top{
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/*

 @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,700;1,400;1,700&family=Lato:ital,wght@0,400;0,700;1,400;1,700&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Lora:ital,wght@0,400;0,700;1,400;1,700&family=Merriweather:ital,wght@0,400;0,700;1,400;1,700&family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&family=Oswald:wght@400;700&family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&family=Raleway:ital,wght@0,400;0,700;1,400;1,700&family=Roboto:ital,wght@0,400;0,700;1,400;1,700&display=swap');

*/

.logo-preview{
	max-height: 174px;
	max-width: 100%;
	margin: 0 auto;
	display: block;
  padding: 5px;
}

@media (min-width: 576px){
  .modal-dialog .modal-dialog .modal-body {
      min-height: auto;
  }
}

#new-card-modal .modal-content{
  background-color: #F7F7F7;
}

.advert-wrapper{
  cursor: pointer;
  position: relative;
  margin-left: auto;
  width: 55%;
}

.block-container.mobile .advert-wrapper{
  width: 100%; 
}

.advert-wrapper:hover::after{
  text-decoration: underline;
}

.advert-wrapper:after{
  content: "Remove this Ad?";
  color: #333;
  position: absolute;
  top: 5px;
  right: 210px;
  font-size: 10px;
  font-family: Arial, sans-serif;
  font-style: italic;

  background-color: rgb(255, 255, 255);
  border-radius: 3px;
  padding: 2px 7px;
}
.sd-advert{
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

/*
.sd-block.p-0 .advert-wrapper:after{
  right: 11px;
}
.sd-block.p-1 .advert-wrapper:after{
  right: 7px;
}
.sd-block.p-2 .advert-wrapper:after{
  right: 3px;
}
.sd-block.p-3 .advert-wrapper:after{
  right: -5px;
}
.sd-block.p-4 .advert-wrapper:after{
  right: -13px;
}
.sd-block.p-5 .advert-wrapper:after{
  right: -37px;
}
*/

/* add close to noty */

</style>
